<!-- Copyright (c) 2022 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="designer-v2-main">
    <div class="format" v-if="!viewMode" :style="{ width: 'fit-content', minWidth: isEdit ? '400px' : '' }">
      <button @click="editPreviewClicked" ref="editPreviewButton">{{ isEdit ? 'Preview' : 'Edit' }}</button>
      <!-- <Input :inputValue.sync="contCount" placeholder="Container Count" /> -->
      <div v-if="(selectedFieldObject || selectedFields.length > 0) && isEdit">
        <div class="field-title">
          <b>Field Details</b>
          <CheckBox v-show="selectedFields.length == 1" :isChecked.sync="selectedFieldObject['isImage']" title="Field is Image" />
        </div>
        <textarea v-show="selectedFields.length == 1" v-model="selectedFieldObject['value']" class="value-textarea" ref="editTextarea"></textarea><br v-show="selectedFields.length == 1">
        <CheckBox v-show="selectedFieldObject['type'] == 'text' && selectedFields.length == 1" title="Auto Grow" :isChecked.sync="selectedFieldObject['autoGrow']" />
        <CheckBox v-show="selectedFieldObject['type'] == 'text' && selectedFields.length == 1" title="Fixed Position" :isChecked.sync="selectedFieldObject['fixPosition']" />
        <CheckBox v-show="selectedFieldObject['type'] == 'text' && selectedFields.length == 1" title="Header / Footer" :isChecked.sync="selectedFieldObject['headerFooter']" />
        <span class="span-title" v-show="selectedFields.length == 1">Top</span><span v-show="selectedFields.length == 1" style="margin-right: 5px">:</span><input v-show="selectedFields.length == 1" type="range" v-model="selectedFieldObject['top']" min="0" max="1500"><input style="max-width: 100px" v-show="selectedFields.length == 1" type="number" v-model="selectedFieldObject['top']" ref="topInput"><br v-show="selectedFields.length == 1">
        <span class="span-title" v-show="selectedFields.length == 1">Left</span><span v-show="selectedFields.length == 1" style="margin-right: 5px">:</span><input v-show="selectedFields.length == 1" type="range" v-model="selectedFieldObject['left']" min="0" max="1500"><input style="max-width: 100px" v-show="selectedFields.length == 1" type="number" v-model="selectedFieldObject['left']" ref="leftInput"><button @click="fieldPositioning('leftPadding')">←</button><br v-show="selectedFields.length == 1">
        <span class="span-title" v-show="selectedFields.length == 1">Height</span><span v-show="selectedFields.length == 1" style="margin-right: 5px">:</span><input v-show="selectedFields.length == 1" type="range" v-model="selectedFieldObject['height']" min="0" max="1500"><input style="max-width: 100px" v-show="selectedFields.length == 1" type="number" v-model="selectedFieldObject['height']" ref="heightInput"><br v-show="selectedFields.length == 1">
        <span class="span-title" v-show="selectedFields.length == 1">Width</span><span v-show="selectedFields.length == 1" style="margin-right: 5px">:</span><input v-show="selectedFields.length == 1" type="range" v-model="selectedFieldObject['width']" min="0" max="1500"><input style="max-width: 100px" v-show="selectedFields.length == 1" type="number" v-model="selectedFieldObject['width']" ref="widthInput"><button @click="fieldPositioning('fillWidth')">↔</button><br v-show="selectedFields.length == 1">
        <span v-if="!selectedFieldObject['isImage']">Font Size:</span> <input v-if="!selectedFieldObject['isImage']" type="number" v-model="selectedFieldObject['fontSize']" @input="fontSizeChanged"><br>
        <div class="text-properties" v-if="!selectedFieldObject['isImage']">
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['bold'] } ]" @click="textPropertiesClicked('bold')">B</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['italic'] } ]" @click="textPropertiesClicked('italic')">I</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['textAlign'] == 'left' } ]" @click="textAlignPropertiesClicked('left')">
            <img src="https://dsmlib.logistics.systems/Icons/LeftAlign.png" alt="">
          </div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['textAlign'] == 'center' } ]" @click="textAlignPropertiesClicked('center')">
            <img src="https://dsmlib.logistics.systems/Icons/CenterAlign.png" alt="">
          </div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['textAlign'] == 'right' } ]" @click="textAlignPropertiesClicked('right')">
            <img src="https://dsmlib.logistics.systems/Icons/RightAlign.png" alt="">
          </div>

          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['verticalAlign'] == 'top' } ]" @click="verticalTextAlignPropertiesClicked('top')">
            <img src="https://dsmlib.logistics.systems/Icons/LeftAlign.png" alt="">
          </div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['verticalAlign'] == 'middle' } ]" @click="verticalTextAlignPropertiesClicked('middle')">
            <img src="https://dsmlib.logistics.systems/Icons/CenterAlign.png" alt="">
          </div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['verticalAlign'] == 'bottom' } ]" @click="verticalTextAlignPropertiesClicked('bottom')">
            <img src="https://dsmlib.logistics.systems/Icons/RightAlign.png" alt="">
          </div>
        </div>
        <div v-show="selectedFields.length == 1">Border:</div>
        <div class="text-properties" v-show="selectedFields.length == 1">
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['border'].split(',').includes('BT') } ]" @click="borderPropertiesClicked('BT')" title="Border Top">BT</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['border'].split(',').includes('BR') } ]" @click="borderPropertiesClicked('BR')" title="Border Right">BR</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['border'].split(',').includes('BB') } ]" @click="borderPropertiesClicked('BB')" title="Border Bottom">BB</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['border'].split(',').includes('BL') } ]" @click="borderPropertiesClicked('BL')" title="Border Left">BL</div>
          <CheckBox v-if="!selectedFieldObject['isTable']" title="Only show border with value" :isChecked.sync="selectedFieldObject['showBorderWithValue']" />
        </div>
        <div v-show="!selectedFieldObject['isTable'] && selectedFields.length == 1">Print At:</div>
        <div class="text-properties" v-show="!selectedFieldObject['isTable'] && selectedFields.length == 1">
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['printAt'] == 'AP' } ]" @click="printAtPropertiesClicked('AP')" title="Print at All Pages">AP</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['printAt'] == 'FP' } ]" @click="printAtPropertiesClicked('FP')" title="Print at First Page only">FP</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['printAt'] == 'OP' } ]" @click="printAtPropertiesClicked('OP')" title="Print at Odd Pages only">OP</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['printAt'] == 'EP' } ]" @click="printAtPropertiesClicked('EP')" title="Print at Even Pages only">EP</div>
          <div :class="[ 'properties-button', { 'selected': selectedFieldObject['printAt'] == 'LP' } ]" @click="printAtPropertiesClicked('LP')" title="Print at Last Page only">LP</div>
          <!-- <input style="margin-left: 5px" /> -->
        </div>
        <CheckBox v-show="selectedFields.length == 1" :isChecked.sync="selectedFieldObject['isTable']" title="Field is Table" @checkBoxClicked="isTableCheckboxClicked" />
        <div v-if="selectedFieldObject['isTable'] && this.selectedFields.length == 1">
          <Input placeholder="Table Key" :inputValue.sync="selectedFieldObject['tableOptions']['tableKey']" />
          Top Row Offset: <input type="number" v-model="selectedFieldObject['tableOptions']['topOffset']"><br>
          Start Index: <input type="number" v-model="selectedFieldObject['tableOptions']['startIndex']"><br>
          Max row per page: <input type="number" v-model="selectedFieldObject['tableOptions']['rowPerPage']">
          <button style="margin-left: 5px" :disabled="selectedFieldObject['tableOptions']['rowPerPage'] == 0" @click="showLastRowTablePosition">Show Last Row</button>
          <CheckBox title="Auto Generate" :isChecked.sync="selectedFieldObject['tableOptions']['autoGenerate']" />
        </div>
        <button v-show="selectedFields.length == 1" style="background-color: red; color: white" @click="deleteFieldClicked">Delete</button>
        <button v-show="selectedFields.length == 1" style="margin-left: 5px" @click="duplicateFieldClicked">Duplicate</button>
      </div>
      <div v-if="selectedPageObject && !selectedFieldObject && isEdit">
        <div><b>Document Details</b></div>
        <button @click="addPageNumberClicked">{{ hasPageNumber ? 'Remove' : 'Add' }} Page Number</button>
        <div v-if="hasPageNumber">
          
        </div>
        <br><br>
        <div><b>Page Details (Page {{ selectedPageIndex + 1 }})</b></div>
        <div>
          Background Image: <b>{{ selectedPageObject['backgroundImage'] }}</b>&nbsp;<button @click="addClearBackgroundImage"
            :style="{ backgroundColor: selectedPageObject['backgroundImage'] ? 'red' : '', color: selectedPageObject['backgroundImage'] ? 'white' : '' }">
            {{ selectedPageObject['backgroundImage'] ? 'Clear' : 'Add' }}
          </button>
        </div>
        <div>Print only if <input type="text" placeholder="key" v-model="selectedPageObject['pageCondition']"> exists</div>
        <div>Page Padding <input type="number" placeholder="0" v-model="selectedPageObject['pagePadding']" /></div>
        <div>Page Header <input type="number" placeholder="0" v-model="selectedPageObject['pageHeader']" /></div>
        <div>Page Footer <input type="number" placeholder="0" v-model="selectedPageObject['pageFooter']" /></div>
        <div>
          <button @click="deletePageClicked" style="background-color: red; color: white">Delete Page</button>
        </div>
      </div>
    </div>

    <div v-show="isEdit" class="editor" :style="[ editorStyling, { opacity: viewMode ? '0' : '1' } ]" @scroll="editorScrolled" @wheel="editorWheel" @keydown="editorKeyDown" ref="editor" tabindex="99">
      <div v-if="showToolbarMenu || showSampleData" class="toolbar-background" @click="showToolbarMenu = false; showSampleData = false"></div>
      
      <div class="editor-toolbar" ref="toolbar">
        <div class="toolbar-title">{{ openedFile ? openedFile['filename'] : 'Untitled' }}{{ hasChanges ? '*' : '' }}</div>
        <img class="menu-icon editor-button" src="https://dsmlib.logistics.systems/Icons/Menu.png" alt="Nope" @click="showToolbarMenu = !showToolbarMenu">
        <div class="spacer"></div>
        <div class="editor-button" title="Bind Sample Data">
          <div @click="showSampleData = !showSampleData">{}</div>
          <div v-show="showSampleData" class="sample-data">
            <div class="sample-data-items" v-for="(d, i) in sampleDataList" :key="i">
              <div @click="sampleDataClicked(d['file'])">{{ selectedSampleData == d['file'] ? '✓' : '' }} {{ d['file'] }}</div>
              <button @click="editSampleData(d['file'])">Edit</button>
            </div>
            <button @click="addNewSampleData">Add New Data</button>
          </div>
        </div>
        <div class="editor-button" @click="pageScale -= 0.1">-</div>
        <div class="scale">{{ Math.round(pageScale * 100) }}%</div>
        <div class="editor-button" @click="pageScale += 0.1">+</div>

        <div v-if="showToolbarMenu" class="editor-toolbar-menu">
          <div class="toolbar-item" @click="toolbarClicked('newfile')">
            <div>New File</div>
            <div>Ctrl+Alt+N</div>
          </div>
          <div class="splitter"></div>
          <div class="toolbar-item" @click="toolbarClicked('addpage')">
            <div>Add Page</div>
            <div>Ctrl+Alt+P</div>
          </div>
          <div class="splitter"></div>
          <div class="toolbar-item" @click="toolbarClicked('save')">
            <div>Save Form</div>
            <div>Ctrl+S</div>
          </div>
          <div class="toolbar-item" @click="toolbarClicked('saveas')">
            <div>Save Form As</div>
            <div>Ctrl+Shift+S</div>
          </div>
          <div class="toolbar-item" @click="toolbarClicked('load')">
            <div>Load Form</div>
            <div>Ctrl+O</div>
          </div>
          <div class="splitter"></div>
          <div class="toolbar-item" @click="toolbarClicked('import')">
            <div>Import from DesignerV1</div>
            <div></div>
          </div>
        </div>
      </div>

      <!-- #region Add Popup -->
      <div v-if="showAddPopup" class="editor-popup" :style="{
        top: `${this.editorScrollTop}px`,
        left: `${this.editorScrollLeft}px`,
      }">
        <div class="editor-popup-content">
          <div class="center-text">Please choose your page size</div>
          <Dropdown placeholder="Page Size" textAlign="center" :items="pageSizesList" itemKey="page" :selectedObject.sync="selectedPageSize" 
            :errorMessage.sync="selectedPageSizeError" />
          <Dropdown placeholder="Page Orientation" textAlign="center" :items="pageOrientationList" itemKey="orientation" :selectedObject.sync="selectedPageOrientation" 
            :errorMessage.sync="selectedPageOrientationError" />
          <button @click="confirmAddPageClicked(true)">Add Page</button>
          <button class="button-cancel" @click="confirmAddPageClicked(false)">Cancel</button>
        </div>
      </div>
      <!-- #endregion -->

      <!-- #region Save Popup -->
      <div v-if="showSavePopup" class="editor-popup" :style="{
        top: `${this.editorScrollTop}px`,
        left: `${this.editorScrollLeft}px`,
      }">
        <div class="editor-popup-content">
          <div class="center-text">Please select a folder and enter the filename</div>
          <Dropdown :items="allFolders" itemKey="folder" :selectedObject.sync="selectedLoadFolder" placeholder="Select Report Folder"
            @selected="reportFolderSelected" />
          <Input placeholder="Filename" :inputValue.sync="saveFilename" textAlign="center" :errorMessage.sync="saveFilenameError"
            :isDisabled="selectedLoadFolder ? false : true" />
          <button @click="confirmSaveFile(true)">Save File</button>
          <button class="button-cancel" @click="confirmSaveFile(false)">Cancel</button>
        </div>
      </div>
      <!-- #endregion -->

      <!-- #region Load Form popup -->
      <div v-if="showForms" class="editor-popup" :style="{
        top: `${this.editorScrollTop}px`,
        left: `${this.editorScrollLeft}px`,
      }">
        <div class="editor-popup-content full-height">
          <Dropdown :items="allFolders" itemKey="folder" :selectedObject.sync="selectedLoadFolder" placeholder="Select Report Folder"
            @selected="reportFolderSelected" />
          <Input placeholder="Search" style="margin: 5px 0" :inputValue.sync="loadSearch" :isDisabled="selectedLoadFolder ? false : true" />
          <div class="editor-popup-body">
            <div class="forms-row" v-for="(f, i) in searchedFormsList" :key="i">
              <div class="file-details">
                <div class="filename">{{ f['filename'] }}</div>
                <!-- <div class="folder">in {{ f['folder'] }}</div> -->
                <div class="last-update">Last updated at: {{ new Date(f['lastUpdated']).formatString('yyyy-MM-dd HH:mm') }}</div>
              </div>
              <button title="Delete Form" @click="deleteFormClicked(f)">
                <img src="https://dsmlib.logistics.systems/Icons/Delete.png">
              </button>
              <button @click="formOpenClicked(f)">Open</button>
            </div>
          </div>
          <button class="button-cancel" @click="showForms = false">Cancel</button>
        </div>
      </div>
      <!-- #endregion -->

      <!-- #region Add Background Image popup -->
      <div v-if="showImagesPopup" class="editor-popup" :style="{
        top: `${this.editorScrollTop}px`,
        left: `${this.editorScrollLeft}px`,
      }">
        <div class="editor-popup-content full-height">
          <Input placeholder="Search" style="margin: 5px 0" :inputValue.sync="imageSearch" />
          <div class="editor-popup-body">
            <div class="forms-row" v-for="(f, i) in searchedImageList" :key="i">
              <div class="file-details">
                <div class="filename">{{ f['filename'] }}</div>
                <!-- <div class="folder">in {{ f['folder'] }}</div> -->
                <div class="last-update">Last updated at: {{ new Date(f['lastUpdated']).formatString('yyyy-MM-dd HH:mm') }}</div>
              </div>
              <button @click="imageAddClicked(f)">Add</button>
            </div>
          </div>
          <!-- <button @click="confirmAddPageClicked(true)">Add Page</button> -->
          <button class="button-cancel" @click="showImagesPopup = false">Cancel</button>
        </div>
      </div>
      <!-- #endregion -->
      
      <!-- #region Import popup -->
      <div v-if="showImportPopup" class="editor-popup" :style="{
        top: `${this.editorScrollTop}px`,
        left: `${this.editorScrollLeft}px`,
      }">
        <div class="editor-popup-content full-height">
          <Input placeholder="Search" style="margin: 5px 0" :inputValue.sync="importSearch" />
          <div class="editor-popup-body">
            <div class="forms-row" v-for="(f, i) in searchedImportList" :key="i">
              <div class="file-details">
                <div class="filename">{{ f['filename'] }}</div>
                <!-- <div class="folder">in {{ f['folder'] }}</div> -->
                <div class="last-update">Last updated at: {{ new Date(f['lastUpdated']).formatString('yyyy-MM-dd HH:mm') }}</div>
              </div>
              <button @click="importSelectClicked(f)">Import</button>
            </div>
          </div>
          <!-- <button @click="confirmAddPageClicked(true)">Add Page</button> -->
          <button class="button-cancel" @click="showImportPopup = false">Cancel</button>
        </div>
      </div>
      <!-- #endregion -->
      
      <!-- #region Edit Sample Data popup -->
      <div v-if="showEditSamplePopup" class="editor-popup" :style="{
        top: `${this.editorScrollTop}px`,
        left: `${this.editorScrollLeft}px`,
      }">
        <div class="editor-popup-content full-height">
          <div class="edit-title" v-if="editFileName">Editting {{ editFileName }}</div>
          <div v-else class="edit-title">Create <Input class="new-file-input" textAlign="right" placeholder="New File" :inputValue.sync="newFileName" :errorMessage.sync="newFileNameError" />.json</div>
          <div class="textarea-container">
            <textarea class="edit-textarea" v-model="editData" ref="editTextarea"></textarea>
            <button v-if="editData" @click="beautifyClicked">Beautify</button>
            <div class="json-error" :style="{ opacity: showJsonError ? 1 : 0, transform: `translateY(${showJsonError ? '0' : '100%'})` }">{{ jsonError }}</div>
          </div>
          <button @click="saveSampleData">Save</button>
          <button class="button-cancel" @click="showEditSamplePopup = false">Cancel</button>
        </div>
      </div>
      <!-- #endregion -->

      <div class="page-container" :style="{ transform: `scale(${pageScale})` }" ref="pageContainer">
        <div class="page" v-for="(p, pi) in pdfPages" :key="pi" @click="pageClicked($event, pi)" :style="{
          height: p['orientation'] == 'portrait' ? p['pageHeight'] : p['pageWidth'],
          width: p['orientation'] == 'portrait' ? p['pageWidth'] : p['pageHeight'],
        }" @mousedown="pageMouseDown($event, pi)" @mousemove="pageMouseMove" @mouseup="pageMouseUp">
          <div class="field-text" v-for="(f, fi) in p['fields']" :key="fi" :style="{
              background: f['type'] == 'text' ? 'rgba(50,205,50,0.4)' : 'rgba(50,63,205,0.4)',
              top: `${f['top']}px`,
              left: `${f['left']}px`,
              boxShadow: selectedFieldIndex == `${pi},${fi}` ? `inset 0 0 0 1px ${selectedFieldObject['isTable'] ? 'blue' : 'green'}` : 'none',
              height: f['height'] ? `${f['height']}px` : '',
              width: f['width'] ? `${f['width']}px` : '',
              fontWeight: f['bold'] ? `bold` : '',
              fontStyle: f['italic'] ? `italic` : '',
              fontSize: `${f['fontSize']}px`,
              outline: 'none',
              textAlign: f['textAlign'] || 'left',
              justifyContent: f['textAlign'] ? (f['textAlign'] == 'left' ? 'flex-start' : (f['textAlign'] == 'center' ? 'center' : 'flex-end')) : 'flex-start',
              alignItems: f['verticalAlign'] ? (f['verticalAlign'] == 'top' ? 'flex-start' : (f['verticalAlign'] == 'middle' ? 'center' : 'flex-end')) : 'flex-start',
              pointerEvents: selectDraggingPageIndex >= 0 ? 'none' : '',
            }" @mouseover="textFocus(pi, fi)" @mouseout="textBlur(pi, fi)" @mousedown="textMouseDown($event, pi, fi)" @mouseup="textMouseUp" tabindex="0"
            @dblclick="fieldDoubleClicked">
            <!-- <div>{{ f['value'] }}</div> -->
            {{ f['value'] }}
            <div v-if="selectedFieldIndex == `${pi},${fi}` && selectedFields.length == 1" class="field-resizer top-resizer" @mouseover="resizeHover = true" @mouseout="resizeHover = false"
              @mousedown="fieldResizerMouseDown($event, pi, 'top')"></div>
            <div v-if="selectedFieldIndex == `${pi},${fi}` && selectedFields.length == 1" class="field-resizer bottom-resizer" @mouseover="resizeHover = true" @mouseout="resizeHover = false"
              @mousedown="fieldResizerMouseDown($event, pi, 'bottom')"></div>
            <div v-if="selectedFieldIndex == `${pi},${fi}` && selectedFields.length == 1" class="field-resizer left-resizer" @mouseover="resizeHover = true" @mouseout="resizeHover = false"
              @mousedown="fieldResizerMouseDown($event, pi, 'left')"></div>
            <div v-if="selectedFieldIndex == `${pi},${fi}` && selectedFields.length == 1" class="field-resizer right-resizer" @mouseover="resizeHover = true" @mouseout="resizeHover = false"
              @mousedown="fieldResizerMouseDown($event, pi, 'right')"></div>
            
            <div v-if="selectedFieldIndex == `${pi},${fi}` && selectedFields.length == 1" class="diagonal-resizer top-right-resizer" @mouseover="resizeHover = true" @mouseout="resizeHover = false"
              @mousedown="fieldResizerMouseDown($event, pi, 'topRight')"></div>
            <div v-if="selectedFieldIndex == `${pi},${fi}` && selectedFields.length == 1" class="diagonal-resizer bottom-right-resizer" @mouseover="resizeHover = true" @mouseout="resizeHover = false"
              @mousedown="fieldResizerMouseDown($event, pi, 'bottomRight')"></div>
            <div v-if="selectedFieldIndex == `${pi},${fi}` && selectedFields.length == 1" class="diagonal-resizer top-left-resizer" @mouseover="resizeHover = true" @mouseout="resizeHover = false"
              @mousedown="fieldResizerMouseDown($event, pi, 'topLeft')"></div>
            <div v-if="selectedFieldIndex == `${pi},${fi}` && selectedFields.length == 1" class="diagonal-resizer bottom-left-resizer" @mouseover="resizeHover = true" @mouseout="resizeHover = false"
              @mousedown="fieldResizerMouseDown($event, pi, 'bottomLeft')"></div>
            
            <CheckBox class="multi-field-checkbox" v-if="selectedFields.length > 1 && selectedFields.find(s => s['index'] == `${pi},${fi}`)"
              :isChecked="true" :isDisabled="true" title="" />
          </div>
          <img class="backround-image" v-if="p['backgroundImage']" :src="`/ReportDesigner/GetImageFile?folder=ROTimage&filename=${p['backgroundImage']}`" :style="{
            height: p['orientation'] == 'portrait' ? p['pageHeight'] : p['pageWidth'],
            width: p['orientation'] == 'portrait' ? p['pageWidth'] : p['pageHeight'],
          }">
          <div v-if="fieldDraggingPage == pi" class="dragging-container" @mousemove="fieldDragging"
            ref="draggingContainer"></div>
          <div v-if="fieldResizingPage == pi" class="resize-container" @mousemove="fieldResizing"></div>

          <div v-if="selectDraggingPageIndex == pi" class="page-select-dragging" :style="selectDraggingStyling"></div>
        </div>
      </div>
    </div>

    <div v-if="!isEdit" class="pdf-container" :style="{ width: viewMode ? '100%' : '', marginLeft: viewMode ? '0' : '5px' }">
      <object v-if="!isEdit" :data="pdfData" type=""></object>
    </div>

    <div v-if="showSharePopup" class="share-selection">
      <div class="share-popup-title" style="padding:10px;">
        <img src="https://dsmlib.logistics.systems/Icons/Share.png"/><br />
        Share
      </div>
      <div class="share-popup-container">
        <button @click="mediaShare('mail')" style="background:#505050;color:#FFFFFF;margin:5px;width:115px;"><img src="https://dsmlib.logistics.systems/Icons/WhiteMail.png"/> Email</button>
        <button @click="mediaShare('whatsapp')" style="background:#25D366;color:#FFFFFF;margin:5px;width:115px;"><img src="https://dsmlib.logistics.systems/Icons/WhiteWhatsapp.png"/> WhatsApp</button>
        <button @click="mediaShare('tele')" style="background:#0088cc;color:#FFFFFF;margin:5px;width:115px;"><img src="https://dsmlib.logistics.systems/Icons/Telegram.png"/> Telegram</button>
        <div class="share-copy">
          <input type="text" :value="fileLink" ref="copyBookingConfirmation" class="share-copy-holder">
          <button @click="copyLink"><img src="https://dsmlib.logistics.systems/Icons/Copy.png"/></button>
        </div>
        <div v-if="linkCopied">
          Copied to Clipboard
        </div>
        <div class="share-cancel"> 
          <button @click="showSharePopup = false" style="margin:5px;">Cancel</button>
        </div>
      </div>
    </div>

    <div v-if="pdfLoading" class="pdf-loading">
      <div class="pdf-loading-content">Loading Report</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import jsPDF from 'jspdf';
import { PDFDocument } from 'pdf-lib';
import Input from '../Input.vue';
import axios from 'axios';

export default {
  components: {
    Input
  },
  data: function() {
    return {
      viewerSignal: null,

      pdfURLBlob: '',

      pageScale: 1,
      editorScrollTop: 0,
      editorScrollLeft: 0,

      fieldDraggingPage: -1,
      draggingTimeout: null,
      fieldResizingPage: -1,
      resizeDirection: '',

      fieldStartLeft: 0,
      fieldStartTop: 0,
      fieldStartBottom: 0,
      fieldStartRight: 0,

      showToolbarMenu: false,
      
      showSampleData: false,
      sampleDataList: [],
      selectedSampleData: '',

      openedFile: null,

      isEdit: true,
      pdfData: null,
      textHover: false,
      resizeHover: false,
      moveHover: false,
      isEditting: false,

      selectedPageObject: null,
      selectedFieldIndex: '',
      selectedFieldObject: null,
      selectedPageIndex: -1,

      selectedFields: [],
      
      pageData: {},

      contCount: '0',
      
      pdfPagesToCompare: [],
      pdfPages: [],
      fields: [],

      hasChanges: false,

      pageMouseIsDown: false,
      pageStartXOffset: 0,
      pageStartYOffset: 0,
      selectDraggingPageIndex: -1,
      selectDraggingStyling: {},
      pageSelecting: false,

      //#region Share

      showSharePopup: false,
      linkCopied: false,
      pdfBlob: null,
      pdfLink: '',
      fileLink: '',
      pdfLoading: false,

      //#endregion

      //#region Popup Data
      showAddPopup: false,
      pageSizesList: [
        { page: 'A4', height: '297mm', width: '210mm' },
        { page: 'Letter', height: '279.4mm', width: '215.9mm' },
      ],
      selectedPageSize: null,
      selectedPageSizeError: '',
      pageOrientationList: [
        { orientation: 'Portrait' },
        { orientation: 'Landscape' }
      ],
      selectedPageOrientation: null,
      selectedPageOrientationError: '',

      showForms: false,
      loadSearch: '',
      formsList: [],
      searchedFormsList: [],
      allFolders: [],
      selectedLoadFolder: null,

      showSavePopup: false,
      saveFilename: '',
      saveFilenameError: '',

      showImportPopup: false,
      importSearch: '',
      importList: [],
      searchedImportList: [],

      showImagesPopup: false,
      imageSearch: '',
      formsImageList: [],
      searchedImageList: [],
      
      selectedPageNumber: null,
      selectedPageNumberError: '',

      showEditSamplePopup: false,
      editFileName: null,
      editData: null,
      newFileName: '',
      newFileNameError: '',
      jsonError: '',
      showJsonError: false,
      //#endregion

      //#region Page Numbering
      hasPageNumber: false,
      //#endregion
    }
  },
  props: {
    viewMode: { type: Boolean, default: false },
    reportFile: { type: Array, default: function() { return [] } },
    reportFolder: { type: String, default: '' },
    reportData: { type: [Object, Array], default: function() { return null } },
    show: { type: Boolean, default: false },
    shareContent: { type: Object, default: function() {
      return {
        body: `Your report is available at: {link}`,
        subject: 'Report'
      }
    } },
    canShare: { type: Boolean, default: false },
    canClose: { type: Boolean, default: true },
    backgroundImage: { type: String, default: '' },
    downloadName: { type: String, default: 'Report' },
    showBackground: { type: Boolean, default: true } // use .sync
  },
  computed: {
    editorStyling: function() {
      let isHidden = this.showAddPopup || this.showForms;
      return {
        overflow: isHidden ? 'hidden' : 'auto',
        width: this.viewMode ? '100%' : '',
      };
    }
  },
  methods: {
    editorScrolled: function(e) {
      this.editorScrollTop = e.target.scrollTop;
      this.editorScrollLeft = e.target.scrollLeft;
    },
    editorWheel: function(e) {
      if (!e.ctrlKey) {
        return;
      } else {
        e.preventDefault();
      }

      if (e.wheelDeltaY > 0) { // Go up
        if (this.pageScale > 4.9) {
          return;
        }
        this.pageScale += 0.1;
      } else if (e.wheelDeltaY < 0) { // GO down
        if (this.pageScale < 0.3) {
          return;
        }
        this.pageScale -= 0.1;
      }
    },
    pageClicked: function(e, pageIndex) {
      if (this.textHover) {
        return;
      }

      if (e['shiftKey']) {
        this.addText(e, pageIndex);  
      }
    },
    pageMouseDown: function(e, pageIndex) {
      if (this.textHover) {
        return;
      }

      this.pageMouseIsDown = true;
      this.pageStartXOffset = e.offsetX;
      this.pageStartYOffset = e.offsetY;
      this.selectDraggingPageIndex = pageIndex;
    },
    pageMouseMove: function(e) {
      if (this.pageMouseIsDown) {
        this.pageSelecting = true;
        if (e.offsetX >= this.pageStartXOffset && e.offsetY >= this.pageStartYOffset) { // Dragging from top left to bottom right
          this.selectDraggingStyling = {
            left: `${this.pageStartXOffset}px`,
            top: `${this.pageStartYOffset}px`,
            width: `${e.offsetX - this.pageStartXOffset}px`,
            height: `${e.offsetY - this.pageStartYOffset}px`
          };
        } else if (e.offsetX < this.pageStartXOffset && e.offsetY < this.pageStartYOffset) { // Dragging from bottom right to top left
          this.selectDraggingStyling = {
            left: `${e.offsetX}px`,
            top: `${e.offsetY}px`,
            width: `${this.pageStartXOffset - e.offsetX}px`,
            height: `${this.pageStartYOffset - e.offsetY}px`
          };
        } else if (e.offsetX < this.pageStartXOffset && e.offsetY >= this.pageStartYOffset) { // Dragging from right to left
          this.selectDraggingStyling = {
            left: `${e.offsetX}px`,
            top: `${this.pageStartYOffset}px`,
            width: `${this.pageStartXOffset - e.offsetX}px`,
            height: `${e.offsetY - this.pageStartYOffset}px`
          };
        } else if (e.offsetX >= this.pageStartXOffset && e.offsetY < this.pageStartYOffset) { // Dragging from left to right
          this.selectDraggingStyling = {
            left: `${this.pageStartXOffset}px`,
            top: `${e.offsetY}px`,
            width: `${e.offsetX - this.pageStartXOffset}px`,
            height: `${this.pageStartYOffset - e.offsetY}px`
          };
        }

        this.checkFieldWithinHighlight();
      }
    },
    pageMouseUp: function(e) {
      if (this.textHover) {
        return;
      }
      
      this.pageMouseIsDown = false;
      
      if (this.pageSelecting) {
        this.selectDraggingStyling = {
          left: `0px`,
          top: `0px`,
          width: `0px`,
          height: `0px`
        };
      } else if (this.fieldDraggingPage != -1 || this.fieldResizingPage != -1) {
        this.fieldDraggingPage = -1;
        this.fieldResizingPage = -1;
      } else {
        this.selectedPageObject = this.pdfPages[this.selectDraggingPageIndex];
        this.selectedPageIndex = this.selectDraggingPageIndex;
        this.selectedFieldIndex = '';
        this.selectedFieldObject = null;
        this.selectedFields = [];
      }

      this.selectDraggingPageIndex = -1;
      this.pageSelecting = false;
    },
    checkFieldWithinHighlight: function() {
      let within = this.pdfPages[this.selectDraggingPageIndex]['fields'].filter(f => {
        let fieldMidPoint = { x: (Number(f['left'])) + (Number(f['width']) / 2), y: (Number(f['top']) + (Number(f['height']) / 2)) };
        let selectTop = Number(this.selectDraggingStyling['top'].match(/\d/g).join(''));
        let selectLeft = Number(this.selectDraggingStyling['left'].match(/\d/g).join(''));
        let selectRight = selectLeft + Number(this.selectDraggingStyling['width'].match(/\d/g).join(''));
        let selectBottom = selectTop + Number(this.selectDraggingStyling['height'].match(/\d/g).join(''));
        return fieldMidPoint['y'] > selectTop && fieldMidPoint['y'] < selectBottom && fieldMidPoint['x'] > selectLeft && fieldMidPoint['x'] < selectRight;
      });

      if (within.length > 0) {
        this.selectedFields = within.map(w => {
          let fieldIndex = `${this.selectDraggingPageIndex},${this.pdfPages[this.selectDraggingPageIndex]['fields'].findIndex(f => JSON.stringify(f) == JSON.stringify(w))}`;
          return {
            index: fieldIndex,
            field: w
          }
        });

        let fieldIndex = this.pdfPages[this.selectDraggingPageIndex]['fields'].findIndex(f => JSON.stringify(f) == JSON.stringify(within[0]));
        this.selectedFieldIndex = `${this.selectDraggingPageIndex},${fieldIndex}`;
        this.selectedFieldObject = this.pdfPages[this.selectDraggingPageIndex]['fields'][fieldIndex];
      } else {
        this.selectedFields = [];
        this.selectedFieldObject = null;
        this.selectedFieldIndex = '';
      }
    },

    deletePageClicked: async function() {
      let confirmDelete = await this.$showAlert('warning', 'Page Deletion', `Are you sure you want to delete the select page?`, [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'gray', textColor: 'white' },
      ]);

      if (confirmDelete == 'Delete') {
        this.pdfPages.splice(this.selectedPageIndex, 1);
        this.selectedPageObject = null;
        this.selectedPageIndex = -1;
      }
    },
    addText: function(e, pageIndex, saved, text) {
      let pageContainer = Array.from(this.$refs['pageContainer'].children);
      let boundingRect = pageContainer[pageIndex].getBoundingClientRect();
      let page = this.pdfPages[pageIndex];
      let scaleX = (boundingRect.width / this.pageScale) / (page['orientation'] == 'portrait' ? parseFloat(page['pageWidth']) : parseFloat(page['pageHeight']));
      let scaleY = (boundingRect.height / this.pageScale) / (page['orientation'] == 'portrait' ? parseFloat(page['pageHeight']) : parseFloat(page['pageWidth']));

      let field = saved || {
        value: text || 'Text',
        top: e ? e.offsetY : 0,
        left: e ? e.offsetX : 0,
        scaleX: scaleX,
        scaleY: scaleY,
        width: 50,
        height: 20,
        bold: false,
        italic: false,
        textAlign: 'left',
        verticalAlign: 'top',
        fontSize: 13,
        printAt: 'AP',
        border: '',
        showBorderWithValue: false,
        type: 'text',
        isTable: false,
        isImage: false,
        autoGrow: false,
        fixPosition: true,
        headerFooter: false,
        tableOptions: {},
      };

      if (saved) {
        field['scaleX'] = scaleX;
        field['scaleY'] = scaleY;
        field['top'] = saved['top'];
        field['left'] = saved['left'];
        
        if (!field.hasOwnProperty('isTable')) { // Add property istable if not exists
          field['isTable'] = false;
        }

        if (!field.hasOwnProperty('isImage')) { // Add isImage property if not exists
          field['isImage'] = false;
        }

        if (!field.hasOwnProperty('autoGrow')) {
          field['autoGrow'] = false;
        }

        if (!field.hasOwnProperty('fixPosition')) {
          field['fixPosition'] = true;
        }

        if (!field.hasOwnProperty('headerFooter')) {
          field['headerFooter'] = false;
        }

        if (!field.hasOwnProperty('printAt')) { // Add printAt property if not exists
          field['printAt'] = 'AP';
        }

        if (!field.hasOwnProperty('border')) { // Add border property if not exists
          field['border'] = '';
        }

        if (!field.hasOwnProperty('showBorderWithValue')) { // Add showBorderWithValue property if not exists
          field['showBorderWithValue'] = false;
        }

        if (!field.hasOwnProperty('tableOptions')) { // Added if table options key is not available
          field['tableOptions'] = {};
        } 
        
        if (!field['tableOptions'].hasOwnProperty('topOffset')) { // Add table top offset
          field['tableOptions']['topOffset'] = 0;
        }

        if (!field['tableOptions'].hasOwnProperty('startIndex')) { // Add table start index offset
          field['tableOptions']['startIndex'] = 0;
        }
      }

      this.pdfPages[pageIndex]['fields'].push(field);

      this.$nextTick(() => {
        this.selectedFieldObject = field;
        this.selectedFieldIndex = `${pageIndex},${this.pdfPages[pageIndex]['fields'].length - 1}`;
        this.selectedFields = [{
          index: this.selectedFieldIndex,
          field: this.selectedFieldObject
        }];

        this.$refs['editor'].focus();
      });
    },
    deleteFieldClicked: async function() {
      if (this.selectedFields.length > 0) {
        let confirmDelete = await this.$showAlert('warning', 'Field Deletion', `Are you sure you want to delete the selected field(s)?`, [
          { text: 'Delete', color: 'red', textColor: 'white' },
          { text: 'Cancel', color: 'gray', textColor: 'white' },
        ]);

        if (confirmDelete == 'Delete') {
          this.selectedFields.forEach(f => {
            let index = f['index'].match(/\d{1,}/g);
            let fieldIndex = this.pdfPages[index[0]]['fields'].findIndex(fi => JSON.stringify(fi) == JSON.stringify(f['field']));
            this.pdfPages[index[0]]['fields'].splice(fieldIndex, 1);
          })
  
          this.selectedFieldIndex = '';
          this.selectedFieldObject = null;
          this.selectedFields = [];
        }
      }
    },
    duplicateFieldClicked: function() {
      let pageIndex = this.selectedFieldIndex.match(/\d{1,}/g);
      let fieldToAdd = JSON.parse(JSON.stringify(this.selectedFieldObject));
      fieldToAdd['top'] = Number(fieldToAdd['top']) + Number(fieldToAdd['height']) + 1;
      this.addText(null, pageIndex[0], fieldToAdd);
    },
    isTableCheckboxClicked: function() {
      this.selectedFieldObject['type'] = this.selectedFieldObject['isTable'] ? 'table' : 'text';
      if (this.selectedFieldObject['isTable']) {
        this.selectedFieldObject['tableOptions']['tableKey'] = '';
        this.selectedFieldObject['tableOptions']['topOffset'] = 0;
        this.selectedFieldObject['tableOptions']['startIndex'] = 0;
        this.selectedFieldObject['tableOptions']['rowPerPage'] = 0;
        this.selectedFieldObject['tableOptions']['autoGenerate'] = true;
      } else {
        this.selectedFieldObject['tableOptions'] = {};
      }
    },
    showLastRowTablePosition: function() {
      let pageIndex = this.selectedFieldIndex.match(/\d{1,}/g);
      let toAdd = JSON.parse(JSON.stringify(this.selectedFieldObject));
      toAdd['type'] = 'text';
      toAdd['isTable'] = false;
      toAdd['tableOptions'] = {};
      toAdd['top'] = Number(toAdd['top']) + ((this.selectedFieldObject['tableOptions']['rowPerPage'] - 1) * Number(toAdd['height'])) + (Number(this.selectedFieldObject['tableOptions']['topOffset']) * (this.selectedFieldObject['tableOptions']['rowPerPage'] - 1));

      this.addText(null, pageIndex[0], toAdd);
      setTimeout(() => {
        this.pdfPages[pageIndex[0]]['fields'].pop();
      }, 1000);
    },

    textPropertiesClicked: function(key) {
      this.selectedFields.forEach(s => s['field'][key] = !s['field'][key]);
    },
    printAtPropertiesClicked: function(key) {
      this.selectedFieldObject['printAt'] = key;
    },
    borderPropertiesClicked: function(key) {
      this.selectedFields.forEach(s => {
        let border = s['field']['border'].split(',').filter(b => b);
        let hasBorder = border.includes(key);
        if (hasBorder) {
          let index = border.indexOf(key);
          border.splice(index, 1);
        } else {
          border.push(key);
        }
  
        s['field']['border'] = border.join(',');
      })
    },
    textAlignPropertiesClicked: function(key) {
      this.selectedFields.forEach(s => s['field']['textAlign'] = key);
    },
    verticalTextAlignPropertiesClicked: function(key) {
      this.selectedFields.forEach(s => s['field']['verticalAlign'] = key);
    },

    sampleDataClicked: function(data) {
      if (this.selectedSampleData == data) {
        this.selectedSampleData = '';
      } else {
        this.selectedSampleData = data;
      }
    },

    toolbarClicked: async function(key) {
      let discardChanges = true;
      switch (key) {
        case 'newfile':
          discardChanges = await this.checkUnsavedChanges();
          if (!discardChanges) {
            return;
          }

          this.newFileClicked();
          break;
        case 'addpage':
          this.addPageClicked();
          break;
        case 'save':
          this.saveFormClicked();
          break;
        case 'saveas':
          this.saveFormAsClicked();
          break;
        case 'load':
          discardChanges = await this.checkUnsavedChanges();
          if (!discardChanges) {
            return;
          }

          this.loadFormClicked(key);
          break;
        case 'removebackground':
          this.removeBackgroundClicked();
          break;
        case 'import':
          discardChanges = await this.checkUnsavedChanges();
          if (!discardChanges) {
            return;
          }

          this.importClicked();
          break;
      }

      this.showToolbarMenu = false;
    },
    checkUnsavedChanges: async function() {
      if (this.hasChanges) {
        let confirm = await this.$showAlert('warning', 'Unsaved Changes', 'There are unsaved changes.<br><br>Do you want to discard all the changes?', [
          { text: 'Discard', color: 'red', textColor: 'white' },
          // { text: 'Save and Continue' },
          { text: 'Cancel', color: 'lightgray', textColor: 'gray' },
        ]);

        // if (confirm == 'Save and Continue') {
        //   await this.saveFormClicked();
        // }

        return confirm == 'Discard' || confirm == 'Save and Continue';
      } else {
        return true;
      }
    },

    populatePages: function(data) {
      let res = null;
      let prom = new Promise(r => res = r);
      data.forEach((d, dataIndex) => {
        this.selectedPageSize = this.pageSizesList.find(p => p['page'].toLowerCase() == d['pageFormat']);
        this.selectedPageOrientation = this.pageOrientationList.find(p => p['orientation'].toLowerCase() == d['orientation']);
        this.confirmAddPageClicked(true);

        this.$nextTick(() => {
          d['fields'].forEach(fi => this.addText(null, dataIndex, fi));
          this.pdfPages[dataIndex]['backgroundImage'] = d['backgroundImage'];
          this.pdfPages[dataIndex]['pageCondition'] = d['pageCondition'];
          this.pdfPages[dataIndex]['pagePadding'] = d['pagePadding'] || 0;
          this.pdfPages[dataIndex]['pageHeader'] = d['pageHeader'] || 0;
          this.pdfPages[dataIndex]['pageFooter'] = d['pageFooter'] || 0;
        });
      });

      res();

      return prom;
    },
    createPDF: async function(pdfData) {
      let autoGrowPositionStart = [];

      let doc = new jsPDF({
        unit: 'mm',
        compress: true
      });

      let pageToAdd = JSON.parse(JSON.stringify(this.pdfPages));
      let customPageField = []; // For custom page
      let newPagesGrow = [];
      let count = 0;

      let backgroundImageCache = {}; // stores background image data after getting from the controller, used to avoid re-fetching the same image data
      // key: filename
      // value: image as base64

      let imageCache = {}; // stores image data after downloading from a web resource, used to avoid re-downloading the same image data
      // key: web image resource URL
      // value: image as byte array

      pageToAdd.forEach((p, pi) => {
        let allTableFields = p['fields'].filter(f => f['type'] == 'table');
        allTableFields.forEach(t => t['tableOptions']['startPage'] = pi);
      });
      while (count < pageToAdd.length) {
        let p = pageToAdd[count];

        if (p['pageCondition'] && pdfData) {
          if (!pdfData.hasOwnProperty(p['pageCondition'])) {
            count++;
            break;
          }
        }

        doc.addPage(p['pageFormat'], p['orientation']);
        if (this.showBackground) {
          let img = null;
          if (this.backgroundImage) {
            if (!backgroundImageCache[this.backgroundImage]) { // if background image to be added isn't in the cache
              const backgroundImageData = await this.$apiCallV2(`/ReportDesigner/GetImageFile?folder=ROTimage&filename=${this.backgroundImage}&base64=1`);
              backgroundImageCache[this.backgroundImage] = backgroundImageData; // get background image as base64 and store in cache
            }
            img = backgroundImageCache[this.backgroundImage];
          } else if (p['backgroundImage']) {
            if (!backgroundImageCache[p['backgroundImage']]) { // if background image to be added isn't in the cache
              const backgroundImageData = await this.$apiCallV2(`/ReportDesigner/GetImageFile?folder=ROTimage&filename=${p['backgroundImage']}&base64=1`);
              backgroundImageCache[p['backgroundImage']] = backgroundImageData; // get background image as base64 and store in cache
            }
            img = backgroundImageCache[p['backgroundImage']]
          }

          if (img) {
            let width = p['orientation'] == 'portrait' ? parseFloat(p['pageWidth']) : parseFloat(p['pageHeight']);
            let height = p['orientation'] == 'portrait' ? parseFloat(p['pageHeight']) : parseFloat(p['pageWidth']);
            doc.addImage(img, 'png', 0, 0, width, height);
          }
        }

        let autoGrowFields = p['fields'].filter(f => f['autoGrow']); // Get all the fields that autoGrow is true
        autoGrowFields.sort((a, b) => Number(a['top']) - Number(b['top'])); // Make sure that it is sorted based on the top one first
        let notAutoGrowFields = p['fields'].filter(f => !f['autoGrow']); // Get all the fields that autoGrow is false
        notAutoGrowFields.sort((a, b) => Number(a['top']) - Number(b['top'])); // Make sure that it is sorted based on the top one first
        p['fields'] = autoGrowFields.concat(notAutoGrowFields); // Make sure that all the autoGrow fields are at the top

        let tableRowToAdd = 0;
        let tableTop = [];

        for (const f of p['fields']) {
          if (f['printAt'] != 'AP' && pdfData) {
            let customIndex = customPageField.indexOf(f);
            if (customIndex < 0) {
              customPageField.push(f);
            }
            continue;
          }

          doc.setFont(undefined, f['italic'] ? 'italic' : 'normal', f['bold'] ? 'bold' : 'normal');
          doc.setFontSize(f['fontSize']);

          let { toDivideLeft, toDivideTop, left, top } = this.getTextPositioning(p, f);

          let value = f['value'];
          let keys = value.match(/({)(.*?)(?=})/g) || [];

          let valueToAdd = [];
          if (f['type'] == 'table' && pdfData) {
            if (Array.isArray(pdfData[f['tableOptions']['tableKey']])) {
              let tableData = pdfData[f['tableOptions']['tableKey']].slice(f['tableOptions']['startIndex']);
              tableData.forEach((td, i) => {
                let tableValue = f['value'];
                keys.forEach(k => tableValue = tableValue.replace(`{${k.substring(1)}}`, td[k.substring(1)] || ''))
                valueToAdd.push(tableValue);
              });

              if (f['tableOptions']['rowPerPage'] > 0) {
                let startPage = f['tableOptions']['startPage'] || 0;
                let startIndex = (count - startPage) * Number(f['tableOptions']['rowPerPage']);
                let endIndex = startIndex + Number(f['tableOptions']['rowPerPage']);
                if (startIndex < tableData.length) {
                  valueToAdd = valueToAdd.slice(startIndex, endIndex);
                  if (endIndex < tableData.length && f['tableOptions']['autoGenerate'] && count == pageToAdd.length - 1) {
                    pageToAdd.push(p);
                  }
                }
              }
            }
          } else if (f['type'] != 'table' && pdfData) {
            keys.forEach(k => value = value.replace(`{${k.substring(1)}}`, pdfData[k.substring(1)] || ''))
            valueToAdd.push(value);
          } else {
            valueToAdd.push(value);
          }

          for (let i = 0; i < valueToAdd.length; i++) {
            const v = valueToAdd[i];

            let tableTopIndex = tableTop.findIndex(tt => tt['top'] == top);
            let toStart = tableTop.filter((tt, tti) => tti < tableTopIndex).map(tt => tt['toAdd']).reduce((a, b) => a + b, 0);
            if (f['type'] == 'table') {
              if (i == 0) {
                if (tableTopIndex >= 0) {
                  tableRowToAdd = toStart;
                } else {
                  tableTop.push({ top: top, toAdd: tableTop.map(tt => tt['toAdd']).reduce((a, b) => a + b, 0) });
                }
              } else if (i > 0) {
                top += Number(f['tableOptions']['topOffset']);
                tableRowToAdd += f['height'] / toDivideTop;
                if (tableTopIndex >= 0) {
                  tableTop[tableTopIndex]['toAdd'] = tableRowToAdd;
                }
              }
            }

            if (f['isImage'] && pdfData) {
              try {
                if (!imageCache[v]) { // if image to be added in the page isn't in the cache
                  const imageData = await axios({ // download image data from web resource
                    method: "GET",
                    url: v,
                    responseType: "arraybuffer",
                  });
                  imageCache[v] = new Uint8Array(imageData.data); // store image data in cache as a byte array
                }
                doc.addImage(imageCache[v], 'png', left / toDivideLeft, (top + (i * f['height'])) / toDivideTop, Number(f['width']) / toDivideLeft, Number(f['height']) / toDivideTop);
              } catch (error) {}
            } else { // Adding text to the PDF
              let topChanged = autoGrowPositionStart.filter(g => f['top'] > g['top']);
              let toAdd = topChanged.map(t => t['add']).reduce((a, b) => a + b, 0);
              let toAddValue = (toAdd > 0 ? ((toAdd + (i * f['height'])) / toDivideTop) : 0);
              if (i == 0) {
                toAddValue += tableRowToAdd;
              } else if (i > 0) {
                toAddValue += toStart;
                // console.log(i, tableTopIndex, toStart);
              }

              if (f['fixPosition']) {
                toAddValue = 0;
              }
              
              let textWidth = f['width'] / toDivideLeft;
              let textTop = ((top + (i * f['height'])) / toDivideTop) + toAddValue;
              let pagePaddingBottom = Number(p['pageHeight'].match(/\d/g).join('')) - ((Number(p['pagePadding']) || 0) / toDivideTop);
              let pagePaddingTop = (Number(p['pagePadding']) || 0) / toDivideTop;
              let pageHeader = (Number(p['pageHeader']) || 0) / toDivideTop;
              let pageFooter = (Number(p['pageFooter']) || 99999) / toDivideTop;

              let currentGrow = null;
              if (f['autoGrow']) {
                let textLine = doc.splitTextToSize(v, textWidth);
                let height = Number((f['fontSize'] * 1.538461538461538).toFixed(4)) * textLine.length;
                let current = {
                  top: f['top'],
                  add: Number((f['fontSize'] * 1.538461538461538).toFixed(4)) * (textLine.length - 1),
                  height: height,
                  texts: textLine,
                  maxLine: Math.floor(((pagePaddingBottom <= pageFooter ? pagePaddingBottom : pageFooter) - textTop) / (Number((f['fontSize'] * 1.538461538461538).toFixed(4) / toDivideTop)))
                };
                autoGrowPositionStart.push(current);
                currentGrow = current;
              }
              
              let extraTop = (currentGrow ? Number(currentGrow['height']) : (f['height'])) / toDivideTop;
              let fieldBottom = textTop + toAddValue + extraTop;
              let toSplit = currentGrow ? (currentGrow['maxLine'] > 0 ? currentGrow['texts'].length > currentGrow['maxLine'] : false) : false;

              if (i > 0 && toAddValue > 0) {
                textTop -= ((f['height'] / toDivideTop) * i);
                fieldBottom = textTop + (f['height'] / toDivideTop);
              }

              let newValue = v;
              let addTextToPage = true;

              if ((fieldBottom > pagePaddingBottom || fieldBottom > ((pageFooter * toDivideTop) == 99999 ? pagePaddingBottom : (pagePaddingBottom - pageFooter))) && !f['headerFooter']) {
                if (f['type'] == 'table') {
                  if (!f['tableOptions']['autoGenerate']) {
                    continue;
                  }
                }
                addTextToPage = false;
                let newField = JSON.parse(JSON.stringify(f));
                if (toSplit) {
                  addTextToPage = true;
                  newValue = currentGrow['texts'].slice(0, currentGrow['maxLine']).join('\n');
                  newField['value'] = currentGrow['texts'].slice(currentGrow['maxLine'], currentGrow['texts'].length).join('\n');
                }
                newPagesGrow.push({ page: count + 2, field: newField, pageDetails: p, tableDataIndex: i });
              }

              if (addTextToPage) {
                doc.text(newValue, left / toDivideLeft, textTop, {
                  baseline: f['verticalAlign'] || 'top',
                  align: f['textAlign'] || 'left',
                  maxWidth: textWidth
                });
                
                if ((f['border'] && v) || (f['border'] && !f['showBorderWithValue'])) {
                  doc.setDrawColor('black');
                  this.getBorderPositions(f, toDivideTop, toDivideLeft).forEach(b => {
                    let y1 = b['y1'] + toAddValue + ((f['height'] / toDivideTop) * i);
                    let y2 = b['y2'] + toAddValue + ((f['height'] / toDivideTop) * i);
                    if (f['type'] == 'table' && i > 0) {
                      if (Number(f['tableOptions']['topOffset']) > 0) {
                        y1 += ((Number(f['tableOptions']['topOffset']) / toDivideTop) * i);
                        y2 += ((Number(f['tableOptions']['topOffset']) / toDivideTop) * i);
                      }
                      if (toAddValue > 0) {
                        y1 -= ((f['height'] / toDivideTop) * i);
                        y2 -= ((f['height'] / toDivideTop) * i);
                      }
                    }
                    doc.line(b['x1'], y1, b['x2'], y2, 'S');
                  });
                }
              }
            }
          }
        }
        count++;
      }

      doc.deletePage(1);

      if (pdfData) {
        pageToAdd.forEach((p, pi) => {
          doc.setPage(pi + 1);
          let hasAutoPaging = p['fields'].find(f => f['value'].includes('{autoPage}'));
          if (hasAutoPaging) {
            let value = hasAutoPaging['value'].replace('{autoPage}', `${pi + 1} of ${pageToAdd.length}`);
            let { toDivideLeft, toDivideTop, left, top } = this.getTextPositioning(p, hasAutoPaging);
            doc.setFont(undefined, hasAutoPaging['italic'] ? 'italic' : 'normal', hasAutoPaging['bold'] ? 'bold' : 'normal');
            doc.setFontSize(hasAutoPaging['fontSize']);
            doc.text(value, left / toDivideLeft, top / toDivideTop, {
              baseline: hasAutoPaging['verticalAlign'] || 'top',
              align: hasAutoPaging['textAlign'] || 'left',
              maxWidth: hasAutoPaging['width'] / toDivideLeft
            });
          }
        });

        for (const f of customPageField) {
          let pageNumber = [];
          let index = 1;
          switch (f['printAt']) {
            case 'FP':
              pageNumber.push(1);
              break;
            case 'OP':
              while (index <= pageToAdd.length) {
                pageNumber.push(index);
                index += 2;
              }
              break;
            case 'EP':
              index = 2;
              while (index <= pageToAdd.length) {
                pageNumber.push(index);
                index += 2;
              }
              break;
            case 'LP':
              pageNumber.push(pageToAdd.length)
              break;
          }

          for (const p of pageNumber) {
            let page = pageToAdd[p - 1];
            doc.setPage(p);

            let value = f['value'];
            let keys = value.match(/({)(.*?)(?=})/g) || [];
            keys.forEach(k => value = value.replace(`{${k.substring(1)}}`, pdfData[k.substring(1)] || ''));

            let { toDivideLeft, toDivideTop, left, top } = this.getTextPositioning(page, f);
            doc.setFont(undefined, f['italic'] ? 'italic' : 'normal', f['bold'] ? 'bold' : 'normal');
            doc.setFontSize(f['fontSize']);
            
            if (f['isImage']) {
              try {
                if (!imageCache[value]) { // if image to be added in the page isn't in the cache
                  const imageData = await axios({ // download image data from web resource
                    method: "GET",
                    url: value,
                    responseType: "arraybuffer",
                  });
                  imageCache[value] = new Uint8Array(imageData.data); // store image data in cache as a byte array
                }
                doc.addImage(imageCache[value], 'png', left / toDivideLeft, top / toDivideTop, Number(f['width']) / toDivideLeft, Number(f['height']) / toDivideTop);
              } catch (error) {}
            } else {
              doc.text(value, left / toDivideLeft, top / toDivideTop, {
                baseline: f['verticalAlign'] || 'top',
                align: f['textAlign'] || 'left',
                maxWidth: f['width'] / toDivideLeft
              });
            }

            if (f['border']) {
              doc.setDrawColor('black');
              this.getBorderPositions(f, toDivideTop, toDivideLeft).forEach(b => {
                doc.line(b['x1'], b['y1'], b['x2'], b['y2'], 'S');
              });
            }
          }
        }

        let padding = newPagesGrow.length > 0 ? (Number(newPagesGrow[0]['pageDetails']['pagePadding']) || 0) : 0;
        let header = newPagesGrow.length > 0 ? (Number(newPagesGrow[0]['pageDetails']['pageHeader']) || 0) : 0;
        let footer = newPagesGrow.length > 0 ? (Number(newPagesGrow[0]['pageDetails']['pageFooter']) || 9999) : 9999;
        let pageHeight = newPagesGrow.length > 0 ? Number(newPagesGrow[0]['pageDetails']['pageHeight'].match(/\d/g).join('')) : 0;

        let start = padding > header ? padding : header;
        let newPages = [];

        let pagesToAdd = [];
        let pageNumberAdd = 0;
        newPagesGrow.sort((a, b) => {
          if (Number(a['field']['top']) < Number(b['field']['top'])) {
            return -1;
          } else if (Number(a['field']['top']) == Number(b['field']['top'])) {
            return a['tableDataIndex'] - b['tableDataIndex'];
          } else {
            return 1;
          }
        });
        
        let offset = newPagesGrow.length > 0 ? Number(newPagesGrow[0]['field']['top']) - start : 0;
        let offsetToAdd = 0;
        newPagesGrow.forEach((np, i) => {
          let p = np['pageDetails'];
          try {
            doc.getPageInfo(np['page'] + pageNumberAdd);
          } catch {
            start = padding > header ? padding : header;
            doc.addPage(p['pageFormat'], p['orientation']);
            doc.setPage(np['page'] + pageNumberAdd);
            newPages.push(np['page'] + pageNumberAdd);
          }

          let f = np['field'];
          let value = f['value'];
          let keys = value.match(/({)(.*?)(?=})/g) || [];
          keys.forEach(k => {
            if (f['type'] == 'table') {
              let tableData = pdfData[f['tableOptions']['tableKey']][np['tableDataIndex']] || '';
              value = value.replace(`{${k.substring(1)}}`, tableData[k.substring(1)] || '');
            } else {
              value = value.replace(`{${k.substring(1)}}`, pdfData[k.substring(1)] || '');
            }
          });

          let { toDivideLeft, toDivideTop, left, top } = this.getTextPositioning(p, f);
          doc.setFont(undefined, f['italic'] ? 'italic' : 'normal', f['bold'] ? 'bold' : 'normal');
          doc.setFontSize(f['fontSize']);

          if (f['isImage']) {
            // try {
            //   doc.addImage(value, 'png', left / toDivideLeft, (top + (i * f['height'])) / toDivideTop, Number(f['width']) / toDivideLeft, Number(f['height']) / toDivideTop);
            // } catch (error) {}
          } else {
            let textWidth = f['width'] / toDivideLeft;

            let footerTop = footer == 9999 ? (9999) : (pageHeight - (footer / toDivideTop));
            let paddingBottomTop = pageHeight - (padding / toDivideTop);
            let bodyHeight = (paddingBottomTop < footerTop ? paddingBottomTop : footerTop) - (start / toDivideTop);
            let maxLine = Math.floor(bodyHeight / (Number((f['fontSize'] * 1.538461538461538).toFixed(4) / toDivideTop)));

            let texts = doc.splitTextToSize(value, textWidth);
            if (texts.length > maxLine) {
              while (texts.length > 0) {
                bodyHeight = (paddingBottomTop < footerTop ? paddingBottomTop : footerTop) - (start / toDivideTop);
                maxLine = Math.floor(bodyHeight / (Number((f['fontSize'] * 1.538461538461538).toFixed(4) / toDivideTop)));

                let valueToPopulate = texts.slice(0, maxLine).join('\n');
                texts.splice(0, maxLine);

                doc.text(valueToPopulate, left / toDivideLeft, start / toDivideTop, {
                  baseline: f['verticalAlign'] || 'top',
                  align: f['textAlign'] || 'left',
                  maxWidth: textWidth
                });
                // if (f['border']) {
                //   doc.setDrawColor('black');
                //   this.getBorderPositions(f, toDivideTop, toDivideLeft).forEach(b => {
                //     doc.line(b['x1'], b['y1'], b['x2'], b['y2'], 'S');
                //   });
                // }

                if (texts.length > 0) {
                  pageNumberAdd++;
                  doc.addPage(p['pageFormat'], p['orientation']);
                  doc.setPage(np['page'] + pageNumberAdd);
                  newPages.push(np['page'] + pageNumberAdd);

                  start = padding > header ? padding : header;
                } else {
                  let currentTextLines = doc.splitTextToSize(valueToPopulate, textWidth);
                  if (currentTextLines.length > 1) {
                    offset -= (Number((f['fontSize'] * 1.538461538461538).toFixed(4)) * (currentTextLines.length - 1));
                  }
                }
              }
            } else {
              let textTop = Number(f['top']) - offset - (np['tableDataIndex'] == 0 ? offsetToAdd : 0);
              if (f['verticalAlign'] == 'middle') {
                textTop += Number(f['height']) / 2;
              } else if (f['verticalAlign'] == 'bottom') {
                textTop += Number(f['height']);
              }

              if (i == 0 && f['type'] == 'table') {
                offsetToAdd = Number(f['height']);
              }

              doc.text(value, left / toDivideLeft, textTop / toDivideTop, {
                baseline: f['verticalAlign'] || 'top',
                align: f['textAlign'] || 'left',
                maxWidth: textWidth
              });
              if (f['border']) {
              doc.setDrawColor('black');
                let borderField = JSON.parse(JSON.stringify(f));
                borderField['top'] = f['verticalAlign'] == 'middle' ? textTop - Number(f['height']) / 2 : (f['verticalAlign'] == 'bottom' ? textTop - Number(f['height']) : textTop);
                this.getBorderPositions(borderField, toDivideTop, toDivideLeft).forEach(b => {
                  doc.line(b['x1'], b['y1'], b['x2'], b['y2'], 'S');
                });
              }
              
              let textLine = doc.splitTextToSize(value, textWidth);
              if (textLine.length > 1) {
                offset -= (Number((f['fontSize'] * 1.538461538461538).toFixed(4)) * (textLine.length - 1));
              }

              if (f['type'] == 'table' && newPagesGrow[i + 1]) {
                if (np['tableDataIndex'] != newPagesGrow[i + 1]['tableDataIndex']) {
                  offset -= f['height'];
                }
              }
            }
          }
        })
      
        let headerFooterFields = this.pdfPages[0]['fields'].filter(f => f['headerFooter']);
        newPages.forEach(p => {
          doc.setPage(p);
          headerFooterFields.forEach(f => {
            let value = f['value'];
            let keys = value.match(/({)(.*?)(?=})/g) || [];
            keys.forEach(k => value = value.replace(`{${k.substring(1)}}`, pdfData[k.substring(1)] || ''));

            let { toDivideLeft, toDivideTop, left, top } = this.getTextPositioning(p, f);
            doc.setFont(undefined, f['italic'] ? 'italic' : 'normal', f['bold'] ? 'bold' : 'normal');
            doc.setFontSize(f['fontSize']);
            
            if (f['isImage']) {
              // try {
              //   doc.addImage(value, 'png', left / toDivideLeft, (top + (i * f['height'])) / toDivideTop, Number(f['width']) / toDivideLeft, Number(f['height']) / toDivideTop);
              // } catch (error) {}
            } else {
              let textWidth = f['width'] / toDivideLeft;
              doc.text(value, left / toDivideLeft, top / toDivideTop, {
                baseline: f['verticalAlign'] || 'top',
                align: f['textAlign'] || 'left',
                maxWidth: textWidth
              });
              // if (f['border']) {
              //   doc.setDrawColor('black');
              //   this.getBorderPositions(f, toDivideTop, toDivideLeft).forEach(b => {
              //     doc.line(b['x1'], b['y1'], b['x2'], b['y2'], 'S');
              //   });
              // }
            }
          })
        })
      }
      return doc.output('arraybuffer');
    },
    mergeAndCreatePDF: async function() {
      this.pdfLoading = true;
      this.isEdit = true;

      let pdfDocumentList = [];
      if (this.reportFile.length > 0) { // For view mode
        for (let index = 0; index < this.reportFile.length; index++) {
          const reportFile = this.reportFile[index];
          await this.formOpenClicked({ folder: this.reportFolder, filename: reportFile });

          if (Array.isArray(this.reportData)) {
            pdfDocumentList.push(await this.createPDF(this.reportData[index] ?? {}));
          } else if (this.reportData) {
            pdfDocumentList.push(await this.createPDF(this.reportData));
          }
        }
      } else { // For editting mode
        if (this.selectedSampleData) {
          const sampleData = (this.$jsonNullToStringV2(this.$deepTrimJsonV3(await this.$apiCallV2(`/ReportDesigner/ReadFiles?folderPath=ReportKeys&fileName=${this.selectedSampleData}`))))['data'];
          pdfDocumentList.push(await this.createPDF(sampleData));
        } else {
          pdfDocumentList.push(await this.createPDF({}));
        }
      }

      let userDetails = await this.$apiCallV2('/Login/GetDetails');
      let viewerSignalId = `${userDetails['LoginUserId']}_${new Date().formatString('yyMMddHHmmss')}`;

      let merged = await PDFDocument.create();
      for (let d of pdfDocumentList) {
        let current = await PDFDocument.load(d);
        let pages = await merged.copyPages(current, current.getPageIndices());
        for (let p of pages) merged.addPage(p);
      }

      let result = await merged.save();
      let blob = new Blob([result.buffer], { type: 'application/pdf' });
      this.pdfURLBlob = URL.createObjectURL(blob);
      
      this.pdfData = `/PDFViewer/Viewer/viewer.html?file=${this.pdfURLBlob}&bg=${this.showBackground ? '1' : '0'}&vid=${viewerSignalId}&sh=${this.canShare ? '1' : '0'}&view=${this.viewMode ? '1' : '0'}&cls=${this.canClose ? '1' : '0'}`;
      this.pdfBlob = blob;
      this.$emit('pdfGenerated', this.pdfData, blob);

      this.viewerSignal = await this.$signal.init('pdfviewerevent');
      this.viewerSignal.on(viewerSignalId, this.viewerEvent);

      this.pdfLoading = false;
      this.isEdit = false;
    },
    editPreviewClicked: async function() {
      this.isEdit = !this.isEdit;
      if (!this.isEdit) {
        await this.mergeAndCreatePDF();
        await this.$sleep(1000);
        this.$refs['editPreviewButton'].focus();
      }
    },

    getTextPositioning: function(page, field) {
      let toDivideLeft = page['orientation'] == 'portrait' ? field['scaleX'] : field['scaleY'];
      let toDivideTop = page['orientation'] == 'portrait' ? field['scaleY'] : field['scaleX'];

      let left = Number(field['left']);
      if (field['textAlign'] == 'center' && Number(field['width'])) {
        left += Number(field['width']) / 2;
      } else if (field['textAlign'] == 'right' && Number(field['width'])) {
        left += Number(field['width']);
      }

      let top = Number(field['top']);
      if (field['verticalAlign'] == 'middle' && Number(field['height'])) {
        let lineCount = field['value'].split('\n').length;
        top += Number(field['height']) / (lineCount + 1);
      } else if (field['verticalAlign'] == 'bottom' && Number(field['height'])) {
        top += Number(field['height']);
      }

      return { toDivideLeft: toDivideLeft, toDivideTop: toDivideTop, left: left, top: top };
    },
    getBorderPositions: function(field, topDivision, leftDivision) {
      let topLeft = {
        x: Number(field['left']) / Number(leftDivision),
        y: Number(field['top']) / Number(topDivision)
      };
      let topRight = {
        x: (Number(field['left']) + Number(field['width'])) / Number(leftDivision),
        y: Number(field['top']) / Number(topDivision)
      };
      let bottomLeft = {
        x: Number(field['left']) / Number(leftDivision),
        y: (Number(field['top']) + Number(field['height'])) / Number(topDivision)
      };
      let bottomRight = {
        x: (Number(field['left']) + Number(field['width'])) / Number(leftDivision),
        y: (Number(field['top']) + Number(field['height'])) / Number(topDivision)
      };

      let borderToDraw = [];
      let borders = field['border'].split(',');
      if (borders.includes('BT')) {
        borderToDraw.push({ x1: topLeft['x'], y1: topLeft['y'], x2: topRight['x'], y2: topRight['y'] });
      }
      if (borders.includes('BR')) {
        borderToDraw.push({ x1: topRight['x'], y1: topRight['y'], x2: bottomRight['x'], y2: bottomRight['y'] });
      }
      if (borders.includes('BB')) {
        borderToDraw.push({ x1: bottomLeft['x'], y1: bottomLeft['y'], x2: bottomRight['x'], y2: bottomRight['y'] });
      }
      if (borders.includes('BL')) {
        borderToDraw.push({ x1: topLeft['x'], y1: topLeft['y'], x2: bottomLeft['x'], y2: bottomLeft['y'] });
      }

      return borderToDraw;
    },

    editorKeyDown: function(e) {
      if (!this.showForms || !this.showEditSamplePopup) {
        return;
      }

      e.preventDefault();
    },

    getPageIndexFromSelectedPage: function() {
      return this.selectedPageNumber['page'].match(/\d/g) - 1;
    },

    deleteFormClicked: async function(form) {
      let confirmDelete = await this.$showAlert('warning', 'Form Deletion', `Are you sure you want to delete ${form['filename']}?`, [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'gray', textColor: 'white' },
      ]);

      if (confirmDelete == 'Delete') {
        await this.$apiCallV2(`/ReportDesigner/DeleteForm?folder=${form['folder']}&filename=${form['filename']}`);
        await this.loadFormClicked();
      }
    },

    reportFolderSelected: async function(e) {
      this.loadSearch = '';
      if (e) {
        let forms = await this.$apiCallV2(`/ReportDesigner/GetAllFiles?folder=${e['folder']}`); // V2
        this.formsList = JSON.parse(JSON.stringify(forms));
        this.searchedFormsList = JSON.parse(JSON.stringify(forms));
      } else {
        this.formsList = [];
        this.searchedFormsList = [];
      }
    },

    fieldPositioning: function(type) {
      this.selectedFields.forEach(f => {
        let [ pageIndex, fieldIndex ] = f['index'].match(/\d{1,}/g).map(i => Number(i));
        let pagePadding = this.pdfPages[pageIndex]['pagePadding'];
        
        switch (type) {
          case 'leftPadding':
            this.pdfPages[pageIndex]['fields'][fieldIndex]['left'] = pagePadding;
            break;
          case 'fillWidth':
            let pageWidth = (this.$refs['pageContainer'].getBoundingClientRect().width / this.pageScale) - (20 * 2);
            let left = Number(this.pdfPages[pageIndex]['fields'][fieldIndex]['left']);
            this.pdfPages[pageIndex]['fields'][fieldIndex]['width'] = pageWidth - left - pagePadding;
            break;
          default:
            break;
        }
      });
    },

    //#region Share button
    copyLink: function() {
      let inputToCopy = this.$refs['copyBookingConfirmation'];
      inputToCopy.select();
      inputToCopy.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(inputToCopy.value);
      this.linkCopied = true;
      setTimeout(() => {
        this.linkCopied = false;
      }, 1000);
    },
    mediaShare: function(app) {
      let url = '';
      let subject = encodeURIComponent(this.shareContent['subject']);
      let body = encodeURIComponent(this.shareContent['body'].split('{link}').join(this.fileLink));

      switch (app) {
        case 'mail':
          url = `mailto:?subject=${subject}&body=${body}`;
          break;
        case 'whatsapp':
          url = `https://wa.me/?text=${body}`;
          break;
        case 'tele':
          url = `https://t.me/share/url?url=${body}`;
          break;
      }

      window.open(url, '_blank');
    },
    generateShareLink: async function() {
      this.showSharePopup = true;
      let fileName = `${this.reportFile[0]}_${this.$dateTime.getDateTime(new Date(), 'yyyyMMddHHmm')}`;
      var folder = this.reportFolder;
      var shareContent = this.shareContent;
      if (this.pdfData) {
        var formData = new FormData();
        formData.append('file', this.pdfBlob, `${fileName.replace('.json', '')}.pdf`);
        formData.append('folder', folder);
        
        this.$fullscreenLoading('Generating Link');
        var bookingConfirmationLink = await this.$apiCallV2('/Upload/UploadFile', formData);
        this.$fullscreenLoading();

        if (bookingConfirmationLink['Files'].length > 0) {
          this.fileLink = bookingConfirmationLink['Files'][0];
          if (shareContent) {
            if (shareContent['body']) {
              this.shareContent['body'] = shareContent['body'];
            }
            if (shareContent['subject']) {
              this.shareContent['subject'] = shareContent['subject'];
            }
          }
        }
        else {
          this.fileLink = "Error Generating Link";
        }
      }
    },
    //#endregion

    //#region Page Details Methods
    addClearBackgroundImage: async function() {
      if (this.selectedPageObject['backgroundImage']) {
        this.selectedPageObject['backgroundImage'] = '';
      } else {
        this.formsImageList = [];
        this.searchedImageList = [];
        this.imageSearch = '';

        this.showImagesPopup = true;
        let images = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTimage');
        let formatted = images.map(f => {
          return {
            extension: f['extension'],
            filename: f['file'],
            lastUpdated: f['lastedit'],
          }
        });
        this.formsImageList = formatted;
        this.searchedImageList = formatted;
      }
    },
    //#endregion

    //#region Toolbar Methods
    newFileClicked: async function() {
      this.pdfPages = [];
      this.pdfPagesToCompare = [];
      this.hasChanges = false;

      this.openedFile = null;

      this.selectedFieldIndex = '';
      this.selectedFieldObject = null;
      this.selectedPageIndex = -1;
      this.selectedPageObject = null;

      this.hasPageNumber = false;
    },
    addPageClicked: function() {
      this.showAddPopup = true;
      this.selectedPageSize = this.pageSizesList[0];
      this.selectedPageOrientation = this.pageOrientationList[0];
    },
    saveFormClicked: async function() {
      if (this.pdfPages.length == 0) {
        this.$showAlert('error', 'Save Empty Document', 'You cannot save an empty document. Please add at least 1 page to save the document.');
        return;
      }

      if (!this.openedFile) {
        this.saveFilename = '';
        this.showSavePopup = true;
      } else {
        await this.$apiCallV2(`/ReportDesigner/SaveReport?folder=${this.openedFile['folder']}&filename=${this.openedFile['filename']}`, { data: this.pdfPages });
        this.pdfPagesToCompare = JSON.parse(JSON.stringify(this.pdfPages));
        this.hasChanges = false;
      }
    },
    saveFormAsClicked: function() {
      if (this.openedFile) {
        this.saveFilename = '';
        this.showSavePopup = true;
      } else {
        this.$showAlert('error', 'No Opened File', 'Please open a file first to save as');
      }
    },
    loadFormClicked: async function(key) {
      let res = null;
      let prom = new Promise(r => res = r);

      this.formsList = [];
      if (key) {
        this.showForms = true;
      }

      if (!this.selectedLoadFolder) {
        let folder = this.allFolders.find(f => f['folder'] == 'ROTForm');
        if (folder) {
          this.selectedLoadFolder = folder;
          await this.reportFolderSelected(this.selectedLoadFolder);
        }
        res();
      } else {
        await this.reportFolderSelected(this.selectedLoadFolder);
        res();
      }

      return prom;
    },
    importClicked: async function() {
      this.importList = [];
      this.searchedImportList = [];
      this.importSearch = '';

      this.showImportPopup = true;
      let v1Forms = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTform'); // V1
      let formatted = v1Forms.map(f => {
        return {
          extension: f['extension'],
          filename: f['file'],
          lastUpdated: f['lastedit'],
        }
      });
      this.importList = JSON.parse(JSON.stringify(formatted));
      this.searchedImportList = JSON.parse(JSON.stringify(formatted));
    },
    //#endregion

    //#region Popup Buttons
    confirmAddPageClicked: function(add) {
      if (add) {
        let error = false;
        if (!this.selectedPageSize) {
          this.selectedPageSizeError = 'Page size is required!';
          error = true;
        }
        if (!this.selectedPageOrientation) {
          this.selectedPageOrientationError = 'Page orientation is required!';
          error = true;
        }

        if (!error) {
          let pageSize = JSON.parse(JSON.stringify(this.selectedPageSize));
          let orientation = JSON.parse(JSON.stringify(this.selectedPageOrientation));
          this.pdfPages.push({
            pageFormat: pageSize['page'].toLowerCase(),
            pageHeight: pageSize['height'],
            pageWidth: pageSize['width'],
            orientation: orientation['orientation'].toLowerCase(),
            backgroundImage: '',
            pageCondition: '',
            fields: [],
          });

          this.showAddPopup = false;
        }
      } else {
        this.showAddPopup = false;
      }
    },

    formOpenClicked: async function(file) {
      this.openedFile = file;
      this.pdfPages = [];

      this.showForms = false;

      let formContent = await this.$apiCallV2(`/ReportDesigner/GetFileContents?folder=${file['folder']}&filename=${file['filename']}`, null, null, {message:''});
      await this.populatePages(formContent || []);
      this.pdfPagesToCompare = JSON.parse(JSON.stringify(this.pdfPages));

      this.selectedFieldIndex = '';
      this.selectedFieldObject = null;
      this.selectedPageIndex = -1;
      this.selectedPageObject = null;
    },

    confirmSaveFile: async function(save) {
      if (save) {
        if (!this.saveFilename || !this.selectedLoadFolder) {
          this.saveFilenameError = 'File name is required!';
        } else {
          await this.$apiCallV2(`/ReportDesigner/SaveReport?folder=${this.selectedLoadFolder['folder']}&filename=${this.saveFilename}.json`, { data: this.pdfPages });
          await this.loadFormClicked();

          console.log(this.formsList);
          console.log(this.openedFile);
          this.openedFile = this.formsList.find(f => f['filename'] == `${this.saveFilename}.json`);
          this.showSavePopup = false;
        }
      } else {
        this.showSavePopup = false;
      }
    },

    importSelectClicked: async function(file) {
      this.pdfPages = [];
      this.openedFile = null;

      let v1Contents = (await this.$apiCallV2(`/ReportDesigner/ReadFiles?folderPath=ROTform&fileName=${file['filename']}`))['data'];

      let formatted = v1Contents['pages'].map(p => {
        return {
          pageFormat: v1Contents['page']['selection'].toLowerCase(),
          pageHeight: `${p['properties']['heightmm']}mm`,
          pageWidth: `${p['properties']['widthmm']}mm`,
          orientation: 'portrait',
          fields: v1Contents['fields'].map(f => {
            if (f['type'] == 'text') { // Handle text type
              return {
                value: f['properties']['value'],
                top: f['posY1'],
                left: f['posX1'],
                scaleX: 0,
                scaleY: 0,
                width: f['posX2'] - f['posX1'],
                height: f['posY2'] - f['posY1'],
                bold: f['properties']['fontWeight'] == 'bold',
                italic: false,
                textAlign: f['properties']['fontJustify'] || 'left',
                verticalAlign: 'top',
                fontSize: f['properties']['fontSize'] ? parseInt(f['properties']['fontSize']) : 13,
                type: f['type']
              }
            } else if (f['type'] == 'table') { // Handle table type
              let columns = [];
              let fieldLeft = f['posX1'];
              let tableWidth = f['posX2'] - f['posX1'];
              f['properties']['columns'].forEach((c, i) => {
                let row = c['rows'][0];
                let fieldWidth = tableWidth * c['width']  / 100;
                columns.push({
                  value: row['value'],
                  top: f['posY1'],
                  left: fieldLeft,
                  scaleX: 0,
                  scaleY: 0,
                  width: fieldWidth,
                  height: row['height'],
                  bold: row['fontWeight'] == 'bold',
                  italic: false,
                  textAlign: row['fontJustify'] || 'left',
                  verticalAlign: 'top',
                  fontSize: row['fontSize'],
                  printAt: 'AP',
                  border: '',
                  type: 'table',
                  isTable: true,
                  isImage: false,
                  tableOptions: {
                    tableKey: f['properties']['itemKey'],
                    rowPerPage: 0,
                    topOffset: 0,
                    autoGenerate: true,
                  },
                });
                fieldLeft += fieldWidth;
              })
              return columns;
            }
          }).filter(f => f).flat(1),
        }
      });
      
      await this.populatePages(formatted);
      this.showImportPopup = false;

      this.selectedFieldIndex = '';
      this.selectedFieldObject = null;
      this.selectedPageIndex = -1;
      this.selectedPageObject = null;
    },

    imageAddClicked: async function(file) {
      let pageIndex = this.pdfPages.indexOf(this.selectedPageObject);
      this.pdfPages[pageIndex]['backgroundImage'] = file['filename'];

      this.showImagesPopup = false;
    },
    //#endregion

    //#region Input methods
    textFocus: function() {
      this.textHover = true;
    },
    textBlur: function() {
      this.textHover = false;
    },
    textMouseDown: function(e, pageIndex, fieldIndex) {
      if (this.resizeHover) { return }

      this.selectedFieldIndex = `${pageIndex},${fieldIndex}`;
      this.selectedFieldObject = this.pdfPages[pageIndex]['fields'][fieldIndex];

      if (!e.ctrlKey) {
        this.selectedFields = [];
      }
      let fieldInlist = this.selectedFields.find(s => s['index'] == `${pageIndex},${fieldIndex}`);
      if (fieldInlist) {
        let indexInList = this.selectedFields.indexOf(fieldInlist);
        this.selectedFields.splice(indexInList, 1);
      } else {
        this.selectedFields.push({
          index: this.selectedFieldIndex,
          field: this.selectedFieldObject
        });
      }

      this.fieldStartLeft = e['offsetX'];
      this.fieldStartTop = e['offsetY'];
      
      this.draggingTimeout = setTimeout(() => {
        this.fieldDraggingPage = pageIndex;
      }, 300);
    },
    textMouseUp: function() {
      if (this.draggingTimeout) {
        clearInterval(this.draggingTimeout);
      }
    },
    fieldDragging: function(e) {
      if (this.fieldDraggingPage > -1) {
        let draggingRect = this.$refs['draggingContainer'][0].getBoundingClientRect();
        let pageWidth = draggingRect['width'] / this.pageScale;
        let pageHeight = draggingRect['height'] / this.pageScale;

        let left = e['offsetX'] - this.fieldStartLeft;
        let top = e['offsetY'] - this.fieldStartTop;
        let right = left + Number(this.selectedFieldObject['width']);
        let bottom = top + Number(this.selectedFieldObject['height']);

        if (top < 0) {
          top = 0;
        }
        if (left < 0) {
          left = 0;
        }
        if (right > pageWidth) {
          left -= (right - pageWidth);
        }
        if (bottom > pageHeight) {
          top -= (bottom - pageHeight);
        }
        
        this.selectedFieldObject['left'] = left;
        this.selectedFieldObject['top'] = top;
      }
    },
    fieldResizerMouseDown: function(e, pageIndex, direction) {
      this.fieldResizingPage = pageIndex;
      this.resizeDirection = direction;

      this.fieldStartBottom = Number(this.selectedFieldObject['top']) + Number(this.selectedFieldObject['height']);
      this.fieldStartRight = Number(this.selectedFieldObject['left']) + Number(this.selectedFieldObject['width']);

      this.fieldStartLeft = e['offsetX'];
      this.fieldStartTop = e['offsetY'];
    },
    fieldResizing: function(e) {
      let height = 0, width = 0;
      switch (this.resizeDirection) {
        case 'top':
          this.selectedFieldObject['top'] = e['offsetY'] - this.fieldStartTop;
          height = this.fieldStartBottom - this.selectedFieldObject['top'];
          this.selectedFieldObject['height'] = height < 0 ? 0 : height;
          break;
        case 'bottom':
          height = (e['offsetY'] - this.fieldStartTop) - this.selectedFieldObject['top'];
          this.selectedFieldObject['height'] = height < 0 ? 0 : height;
          break;
        case 'left':
          this.selectedFieldObject['left'] = e['offsetX'] - this.fieldStartLeft;
          width = this.fieldStartRight - this.selectedFieldObject['left'];
          this.selectedFieldObject['width'] = width < 0 ? 0 : width;
          break;
        case 'right':
          width = (e['offsetX'] - this.fieldStartLeft) - this.selectedFieldObject['left'];
          this.selectedFieldObject['width'] = width < 0 ? 0 : width;
          break;
        case 'topRight':
          this.selectedFieldObject['top'] = e['offsetY'] - this.fieldStartTop;
          height = this.fieldStartBottom - this.selectedFieldObject['top'];
          this.selectedFieldObject['height'] = height < 0 ? 0 : height;
          width = (e['offsetX'] - this.fieldStartLeft) - this.selectedFieldObject['left'];
          this.selectedFieldObject['width'] = width < 0 ? 0 : width;
          break;
        case 'bottomRight':
          height = (e['offsetY'] - this.fieldStartTop) - this.selectedFieldObject['top'];
          this.selectedFieldObject['height'] = height < 0 ? 0 : height;

          width = (e['offsetX'] - this.fieldStartLeft) - this.selectedFieldObject['left'];
          this.selectedFieldObject['width'] = width < 0 ? 0 : width;
          break;
        case 'topLeft':
          this.selectedFieldObject['top'] = e['offsetY'] - this.fieldStartTop;
          height = this.fieldStartBottom - this.selectedFieldObject['top'];
          this.selectedFieldObject['height'] = height < 0 ? 0 : height;
          this.selectedFieldObject['left'] = e['offsetX'] - this.fieldStartLeft;
          width = this.fieldStartRight - this.selectedFieldObject['left'];
          this.selectedFieldObject['width'] = width < 0 ? 0 : width;
          break;
        case 'bottomLeft':
          height = (e['offsetY'] - this.fieldStartTop) - this.selectedFieldObject['top'];
          this.selectedFieldObject['height'] = height < 0 ? 0 : height;
          this.selectedFieldObject['left'] = e['offsetX'] - this.fieldStartLeft;
          width = this.fieldStartRight - this.selectedFieldObject['left'];
          this.selectedFieldObject['width'] = width < 0 ? 0 : width;
          break;
      }
    },
    fontSizeChanged: function(e) {
      this.selectedFields.forEach(s => s['field']['fontSize'] = Number(e.target.value));
    },
    fieldDoubleClicked: function() {
      if (this.$refs['editTextarea']) {
        this.$refs['editTextarea'].focus();
        this.$refs['editTextarea'].select();
      }
    },
    //#endregion

    //#region Sample Data Methods
    jsonShowError: function(text) {
      this.showJsonError = true;
      this.jsonError = text;
      setTimeout(() => {
        this.showJsonError = false;
      }, 3000);
    },
    editSampleData: async function(fileName) {
      let data = (this.$jsonNullToStringV2(this.$deepTrimJsonV3(await this.$apiCallV2(`/ReportDesigner/ReadFiles?folderPath=ReportKeys&fileName=${fileName}`))))['data'];
      this.showEditSamplePopup = true;
      this.showSampleData = false;

      this.editFileName = fileName;
      this.editData = JSON.stringify(data, null, 2);
    },
    saveSampleData: async function() {
      let dataToSave = null;
      try {
        dataToSave = JSON.parse(this.editData);
      } catch (error) {
        this.jsonShowError('Please check your JSON format is correct');
        let errorSplit = error.message.split(' ');
        let cursorPosition = Number(errorSplit.at(-1));

        await this.$nextTick();
        this.$refs['editTextarea'].focus();
        await this.$nextTick();
        this.$refs['editTextarea'].selectedStart = cursorPosition;
        this.$refs['editTextarea'].selectionEnd = cursorPosition;

        return;
      }

      if (!this.editFileName && !this.newFileName) {
        this.newFileNameError = 'Please enter the file name to save';
      } else if (!this.editData) {
        this.jsonShowError('There are no data entered to be saved');
      } else {
        try {
          await this.$apiCallV2(`/ReportDesigner/SaveSampleData?fileName=${this.editFileName || `${this.newFileName}.json`}`, dataToSave);
          this.showEditSamplePopup = false;
        } catch (error) {
          this.jsonShowError('There was an error while saving your file, please try again');
        }
      }
    },
    addNewSampleData: function() {
      this.editData = null;
      this.editFileName = null;

      this.showSampleData = false;
      this.showEditSamplePopup = true;
    },
    beautifyClicked: async function() {
      try {
        this.editData = JSON.stringify(JSON.parse(this.editData), null, 2);
      } catch (error) {
        this.jsonShowError('Please check your JSON format is correct');

        let errorSplit = error.message.split(' ');
        let cursorPosition = Number(errorSplit.at(-1));

        await this.$nextTick();
        this.$refs['editTextarea'].focus();
        await this.$nextTick();
        this.$refs['editTextarea'].selectedStart = cursorPosition;
        this.$refs['editTextarea'].selectionEnd = cursorPosition;
      }
    },
    //#endregion
  
    //#region Page Numbering Methods
    addPageNumberClicked: function() {
      this.hasPageNumber = !this.hasPageNumber;

      if (this.hasPageNumber) {
        this.addText(null, 0, null, '{v2pager}');
      } else {
        let pageNumberField = this.pdfPages[0]['fields'].find(f => f['value'] == '{v2pager}');
        let pageNumberFieldIndex = this.pdfPages[0]['fields'].findIndex(f => JSON.stringify(f) == JSON.stringify(pageNumberField));

        this.pdfPages[0]['fields'].splice(pageNumberFieldIndex, 1);
      }
    },
    //#endregion
  
    //#region Viewer Event Handler
    viewerEvent: function(method) {
      switch (method) {
        case 'togglebg':
          this.$emit('update:showBackground', !this.showBackground)
          break;
        case 'share':
          this.generateShareLink();
          break;
        case 'print':
          const hiddenIFrame = document.createElement('iframe');
          hiddenIFrame.style.display = 'none';
          hiddenIFrame.src = this.pdfURLBlob;
          hiddenIFrame.onload = function () {
            hiddenIFrame.contentWindow.focus();
            hiddenIFrame.contentWindow.print();
          };

          document.body.appendChild(hiddenIFrame);
          this.$emit('printClicked');
          this.$emit('afterprint');
          break;
        case 'download':
          let anchor = document.createElement('a');
          anchor.href = this.pdfURLBlob;
          anchor.download = `${this.downloadName}.pdf`;
          anchor.click();
          break;
        case 'close':
          this.$emit('update:show', false);
          break;
        case 'afterprint':
          this.$emit('afterprint');
          break;
      }
    },
    //#endregion
  },
  async mounted() {
    if (this.viewMode) {
      if (this.reportFile.length == 0 || !this.reportData || (Array.isArray(this.reportData) && this.reportData.length === 0) || !this.reportFolder) {
        console.warn('DesignerV2 - reportFile OR reportData OR reportFolder props are not passed OR is null/undefined');
      } else {
        this.pdfLoading = true;

        // for (let r of this.reportFile) {
        //   console.log("mounted report file iterated");
        //   await this.formOpenClicked({ folder: this.reportFolder, filename: r });
        //   await this.createPDF();
        // }
        // not sure why this is here, this for-loop is already in mergeAndCreatePDF
        // having this for-loop here will make it generate the PDF twice
        // uncomment the for-loop if commenting it out is causing issues

        this.isEdit = false;

        await this.mergeAndCreatePDF();
      }
    } else {
      // API call to get the list of available folders in ReportDesignerV2 folder
      let folders = await this.$apiCallV2('/ReportDesigner/GetAllFolders');
      // Store in a data variable to show it in the load form popup
      this.allFolders = folders.map(f => ({ folder: f }));
      // Get the page sizes from the saved json file
      let savedPageSizes = await this.$apiCallV2('/ReportDesigner/GetPageSizes');
      if (savedPageSizes.length > 0) { this.pageSizesList = savedPageSizes }

      document.addEventListener('keydown', (e) => {
        if (e.key.toLowerCase() == 's' && e.ctrlKey && e.shiftKey) { // Ctrl+Shift+S
          e.preventDefault();
          this.saveFormAsClicked()
        } else if (e.key.toLowerCase() == 's' && e.ctrlKey) { // Ctrl+S
          e.preventDefault();
          this.saveFormClicked();
        } else if (e.key.toLowerCase() == 'n' && e.ctrlKey && e.altKey) { // Ctrl+Alt+N
          e.preventDefault();
          this.newFileClicked()
        } else if (e.key.toLowerCase() == 'p' && e.ctrlKey && e.altKey) { // Ctrl+Alt+P
          e.preventDefault();
          this.addPageClicked()
        } else if (e.key.toLowerCase() == 'o' && e.ctrlKey) { // Ctrl+O
          e.preventDefault();
          this.loadFormClicked(true)
        } else if (e.key.toLowerCase() == 'delete' && e.shiftKey) { // Delete the selected field(s)
          if (this.selectedFieldIndex || this.selectedFields.length > 0) {
            this.deleteFieldClicked();
          }
        } else if (e.key.toLowerCase() == 'f2') { // Auto focus to the text box
          if (this.selectedFieldIndex && this.selectedFields.length == 1) {
            if (this.$refs['editTextarea']) {
              this.$refs['editTextarea'].focus();
              this.$refs['editTextarea'].select();
            }
          }
        } else if (e.key.toLowerCase() == 'd' && e.ctrlKey) { // Duplicate the selected field
          if (this.selectedFields.length == 1) {
            e.preventDefault();
            this.duplicateFieldClicked();
          }
        } else if (e.key.toLowerCase() == 'v' && e.altKey) { // Preview or edit
          e.preventDefault();
          this.editPreviewClicked();
        } else if (e.key.toLowerCase() == 'tab' || (e.key.toLowerCase() == 'tab' && e.shiftKey)) { // Select the next/previous field below the selected field
          if (this.selectedFields.length == 1) {
            e.preventDefault();
            let [ pageIndex, fieldIndex ] = this.selectedFields[0]['index'].split(',').map(n => Number(n));

            let allFieldsLoc = JSON.parse(JSON.stringify(this.pdfPages[pageIndex]['fields']));
            // Sort all the fields based on the location
            allFieldsLoc.sort((a, b) => {
              if (a['top'] > b['top']) { // Sort by y
                return 1;
              } else if (a['top'] == b['top']) { // Has same y sort by x
                if (a['left'] > b['left']) {
                  return 1;
                } else {
                  return -1;
                }
              } else {
                return -1;
              }
            });
            // Get the index of the current field location
            let currentLocIndex = allFieldsLoc.findIndex(a => JSON.stringify(a) == JSON.stringify(this.selectedFields[0]['field']));
            if (currentLocIndex >= 0) {
              let beforeField = allFieldsLoc[currentLocIndex - 1];
              let afterField = allFieldsLoc[currentLocIndex + 1];

              if (!afterField && !e.shiftKey) { return }
              else if (!beforeField && e.shiftKey) { return }

              let beforeIndex = this.pdfPages[pageIndex]['fields'].findIndex(f => JSON.stringify(f) == JSON.stringify(beforeField));
              let afterIndex = this.pdfPages[pageIndex]['fields'].findIndex(f => JSON.stringify(f) == JSON.stringify(afterField));
              this.$nextTick(() => {
                this.selectedFieldObject = this.pdfPages[pageIndex]['fields'][e.shiftKey ? beforeIndex : afterIndex];
                this.selectedFieldIndex = `${pageIndex},${e.shiftKey ? beforeIndex : afterIndex}`;
                this.selectedFields = [{
                  index: this.selectedFieldIndex,
                  field: this.selectedFieldObject
                }];



                this.$nextTick(() => {
                  this.$refs['editTextarea'].focus();
                  this.$refs['editTextarea'].select();
                });
              });
            }
          }
        } else if ((e.key == 'ArrowUp' || e.key == 'ArrowRight' || e.key == 'ArrowDown' || e.key == 'ArrowLeft') && e.altKey) { // Moving the selected field(s)
          e.preventDefault();
          let increment = 1;
          if (e.ctrlKey) {
            increment = 10;
          }
            
          this.selectedFields.forEach(s => {
            let index = s['index'].match(/\d{1,}/g);
            if (e.shiftKey) {
              if (e.key == 'ArrowUp') {
                s['field']['height'] = Number(s['field']['height']);
                s['field']['height'] += increment;
              } else if (e.key == 'ArrowRight') {
                s['field']['width'] = Number(s['field']['width']);
                s['field']['width'] += increment;
              } else if (e.key == 'ArrowDown') {
                s['field']['height'] = Number(s['field']['height']);
                s['field']['height'] -= increment;
              } else if (e.key == 'ArrowLeft') {
                s['field']['width'] = Number(s['field']['width']);
                s['field']['width'] -= increment;
              }
            } else {
              if (e.key == 'ArrowUp') {
                s['field']['top'] = Number(s['field']['top']);
                s['field']['top'] -= increment;
              } else if (e.key == 'ArrowRight') {
                s['field']['left'] = Number(s['field']['left']);
                s['field']['left'] += increment;
              } else if (e.key == 'ArrowDown') {
                s['field']['top'] = Number(s['field']['top']);
                s['field']['top'] += increment;
              } else if (e.key == 'ArrowLeft') {
                s['field']['left'] = Number(s['field']['left']);
                s['field']['left'] -= increment;
              }
            }
          })
        } else if (e.altKey && e.key.toLowerCase() == 't') {
          if (this.$refs['topInput']) {
            this.$refs['topInput'].focus();
            this.$refs['topInput'].select();
          }
        } else if (e.altKey && e.key.toLowerCase() == 'l') {
          if (this.$refs['leftInput']) {
            this.$refs['leftInput'].focus();
            this.$refs['leftInput'].select();
          }
        } else if (e.altKey && e.key.toLowerCase() == 'h') {
          if (this.$refs['heightInput']) {
            this.$refs['heightInput'].focus();
            this.$refs['heightInput'].select();
          }
        } else if (e.altKey && e.key.toLowerCase() == 'w') {
          if (this.$refs['widthInput']) {
            this.$refs['widthInput'].focus();
            this.$refs['widthInput'].select();
          }
        }
      });
      window.onbeforeunload = () => {
        if (this.hasChanges) {
          return `Changes you made may not be saved.`;
        }
      }
    }
  },
  watch: {
    loadSearch: function(val) {
      if (val) {
        this.searchedFormsList = this.formsList.filter(f => f['filename'].toLowerCase().includes(val.toLowerCase()));
      } else {
        this.searchedFormsList = this.formsList;
      }
    },
    importSearch: function(val) {
      if (val) {
        this.searchedImportList = this.importList.filter(f => f['filename'].toLowerCase().includes(val.toLowerCase()));
      } else {
        this.searchedImportList = this.importList;
      }
    },
    imageSearch: function(val) {
      if (val) {
        this.searchedImageList = this.formsImageList.filter(f => f['filename'].toLowerCase().includes(val.toLowerCase()));
      } else {
        this.searchedImageList = this.formsImageList;
      }
    },
    showSampleData: async function(val) {
      if (val) {
        this.sampleDataList = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ReportKeys');
      } else {
        this.sampleDataList = [];
      }
    },
    showBackground: async function(val) {
      await this.mergeAndCreatePDF();
    },

    reportFile: async function(val) {
      await this.mergeAndCreatePDF();
    },

    pdfPages: {
      deep: true,
      handler: function(val) {
        this.hasChanges = JSON.stringify(val) != JSON.stringify(this.pdfPagesToCompare);
      }
    },
    hasChanges: function(val) {
      if (val) {
        document.title = `*${document.title}`;
      } else {
        document.title = document.title.replace(/\*/g, '');
      }
    },

    showForms: function(val) {
      this.loadSearch = '';
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.designer-v2-main {
  overflow: auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 12px;
  position: relative;

  > .format, > object, > .editor {
    height: 100%;
  }

  > object {
    min-width: 70%;
    max-width: 70%;
  }

  > .format {
    width: 100%;
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    overflow: auto;

    > div {
      margin-top: 5px;

      > :not(:first-child) {
        margin-top: 5px;
      }
    }
  }

  > .editor {
    background-color: gray;
    overflow: auto;
    position: relative;
    width: 100%;

    > .toolbar-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
    }

    > .editor-toolbar {
      background-color: rgb(37, 37, 37);
      height: 50px;
      color: white;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 10;
      display: flex;
      align-items: center;

      > .menu-icon {
        height: 50%;
        filter: invert(1);
      }

      > .editor-button {
        cursor: pointer;
        user-select: none;
        margin: 0 5px;
        position: relative;

        > .sample-data {
          position: absolute;
          top: calc(100% + 10px);
          right: 0;
          background-color: rgb(50,50,50);
          max-width: 300px;
          min-width: 300px;
          max-height: 250px;
          overflow: auto;
          border: 1px solid gray;
          display: flex;
          flex-direction: column;

          > .sample-data-items {
            width: 100%;
            padding: 5px;
            white-space: nowrap;
            display: flex;
            align-items: center;
            border-bottom: 1px solid rgba(211,211,211,0.3);

            &:hover {
              background-color: rgb(75,75,75);
            }

            > :first-child {
              width: 100%;
            }

            > button {
              height: fit-content;
              width: fit-content;
              padding: 2px 5px;
            }
          }

          > button {
            height: fit-content;
            width: fit-content;
            padding: 2px 5px;
            margin: 5px;
            align-self: center;
          }
        }
      }

      > .scale {
        min-width: 35px;
        background-color: rgb(70,70,70);
        text-align: center;
      }

      > .toolbar-title {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      > .spacer {
        width: 100%;
      }

      > .editor-toolbar-menu {
        position: absolute;
        top: 100%;
        left: 0;
        background-color: rgb(50, 50, 50);
        min-width: 200px;
        box-shadow: 5px 5px 10px black;

        > .splitter {
          height: 1px;
          background: white;
          width: 100%;
          margin: 5px 0;
        }

        > .toolbar-item {
          padding: 5px 20px;
          cursor: pointer;
          user-select: none;
          display: flex;
          align-items: center;

          &:hover {
            background-color: rgb(70,70,70);
          }

          > :nth-child(1) {
            width: 100%;
            margin-right: 20px;
          }

          > :nth-child(2) {
            white-space: nowrap;
          }
        }
      }
    }

    > .page-container {
      position: absolute;
      left: 0;
      top: 50px;
      width: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      transform-origin: top left;

      > .page {
        background-color: white;
        margin: 20px;
        // transform: scale(0.5);
        transform-origin: top left;
        position: relative;

        > .background {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          // background-color: rgba(255, 0, 0, 0.5);
          z-index: 10;
        }

        > .dragging-container, > .resize-container {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          background-color: transparent;
          z-index: 99;
        }

        > .resize-container {
          // background-color: rgba(255, 255, 0, 0.3);
          background-color: transparent;
        }

        > .page-select-dragging {
          position: absolute;
          border: 1px solid gray;
          background-color: rgba(0, 255, 255, 0.3);
          z-index: 100;
          pointer-events: none;
        }
      }
    }

    > .editor-popup {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background: rgba(0,0,0,0.5);
      z-index: 11;
      display: flex;
      align-items: center;
      justify-content: center;

      > .editor-popup-content {
        max-height: 90%;
        width: 90%;
        display: flex;
        flex-direction: column;
        background-color: white;
        padding: 5px;
        border-radius: 5px;

        > .editor-popup-body {
          overflow: auto;
          height: 100%;

          > .forms-row {
            padding: 5px;
            border: 1px solid lightgray;
            display: flex;
            align-items: center;

            > :not(:first-child) {
              margin-left: 5px;
            }

            > button > img {
              height: 15px;
            }

            &:not(:first-child) {
              margin-top: 5px;
            }

            &:hover {
              background-color: lightgray;
            }

            > :not(button) {
              pointer-events: none;
            }

            > .file-details {
              width: 100%;

              > .filename {
                font-weight: bold;
              }

              > .last-update {
                font-size: 0.75em;
              }
            }
          }
        }

        > :not(:first-child) {
          margin-top: 5px;
        }

        > .button-danger {
          background-color: indianred;
          color: white;
        }

        > .button-cancel {
          background-color: gray;
          color: white;
        }

        > .textarea-container {
          position: relative;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          overflow: hidden;

          > .edit-textarea {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            resize: none;
  
            &:focus {
              outline: none;
            }
          }

          > button {
            position: absolute;
            z-index: 9;
            top: 5px;
            right: 12px;
          }

          > .json-error {
            position: absolute;
            background-color: indianred;
            color: white;
            bottom: 5px;
            padding: 5px 10px;
            border-radius: 5px;
            text-align: center;
            transition: 0.3s;
          }
        }

        > .edit-title {
          font-weight: bold;
          width: 100%;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;

          > .new-file-input {
            max-width: 50%;
            margin-left: 10px;
          }
        }
      }

      > .full-height {
        height: 90%;
      }

      > .center-text {
        align-content: center;
        text-align: center;
      }
    }
  }

  > :not(:first-child) {
    margin-left: 5px;
  }

  > .pdf-container {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    > object {
      width: 100%;
      height: 100%;
    }

    > .pdf-overlay {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background-color: rgb(50,54,57);
      padding: 5px;
      transition: 0.3s;

      > div {
        filter: invert(1);
      }

      > button {
        background-color: indianred;
        color: white;
      }

      > :not(:first-child) {
        margin-left: 10px;
      }

      > img {
        height: 20px;
        cursor: pointer;
        filter: invert(1);
      }
    }
  }

  > .pdf-loading {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 !important;

    > .pdf-loading-content {
      font-size: 1.5em;
      color: white;
      text-shadow: 5px 5px 5px  black;

      &:after {
        animation: dotappear 1s alternate infinite;
        content: '.';
        display: inline-block;
      }
    }
  }
}

.field-title {
  display: flex;
  align-items: center;
  
  > :not(:first-child) {
    margin-left: 5px;
  }
}

.value-textarea {
  resize: none;
  width: 100%;
  height: 100px;
  outline: none;
}

.text-properties {
  display: flex;
  align-items: center;

  > .properties-button {
    background-color: transparent;
    color: black;
    box-shadow: inset 0 0 0 1px black;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    > img {
      width: 20px;
    }
  }

  > :not(:first-child) {
    margin-left: 5px;
  }

  > .selected {
    background-color: gray;
    color: white;
    box-shadow: none;

    > img {
      filter: invert(1);
    }
  }
}

.share-selection {
  position: fixed;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 999;

  > .share-popup-container {
    background-color: white;
    width: 100%;
    max-width: 30%;
    max-height: 60%;
    padding: 10px;
    overflow: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > button > img {
      height: 20px;
    }

    > .share-copy {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      width: 100%;
      padding-top: 10px;
      
      > .share-copy-holder {
        width: 100%;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom: 1px solid rgb(200,200,200);
      }

      > button > img {
        height: 20px;
      }
    }

    > .share-cancel {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  > .share-popup-title {
    width: 100%;
    max-width: 30%;
    background-color: white;
    padding: 10px 0;
    text-align: center;
    font-weight: bold;
    font-size: 14px;

    > img {
      height: 90px;
    }
  }
}

.span-title {
  display: inline-block;
  min-width: 55px;
}

@keyframes dotappear {
  0% {
    content: '.';
  }
  20% {
    content: '..';
  }
  40% {
    content: '...';
  }
  60% {
    content: '....';
  }
  80% {
    content: '.....';
  }
  100% {
    content: '......';
  }
}
</style>

<style lang="scss">
.field-text {
  position: absolute;
  user-select: none;
  z-index: 11;
  top: 0;
  left: 0;
  display: flex;
  
  > div {
    white-space: pre-wrap;
    line-height: 1.15;
    letter-spacing: 0.9px;
    padding: 1px;
    font-family: Arial, sans-serif !important;
  }

  > .field-resizer {
    position: absolute;
    background-color: transparent;
    // background-color: blue;
    border-color: rgba(255,0,0,0.6);;
    border-style: solid;
  }

  > .top-resizer, > .bottom-resizer {
    width: 100%;
    height: 10px;
    left: 0;
    cursor: ns-resize;
  }

  > .top-resizer {
    top: -10px;
    border-width: 2px 0 0 0;
  }

  > .bottom-resizer {
    bottom: -10px;
    border-width: 0 0 2px 0;
  }

  > .left-resizer, > .right-resizer {
    height: 100%;
    width: 10px;
    top: 0;
    cursor: ew-resize;
  }

  > .left-resizer {
    left: -10px;
    border-width: 0 0 0 2px;
  }

  > .right-resizer {
    right: -10px;    
    border-width: 0 2px 0 0;
  }

  > .diagonal-resizer {
    position: absolute;
    height: 9px;
    width: 9px;
    background-color: rgba(255,0,0,0.6);
  }

  > .top-right-resizer {
    top: -10px;
    right: -10px;
    cursor: sw-resize;
  }

  > .bottom-right-resizer {
    bottom: -10px;
    right: -10px;
    cursor: se-resize;
  }

  > .top-left-resizer {
    top: -10px;
    left: -10px;
    cursor: se-resize;
  }

  > .bottom-left-resizer {
    bottom: -10px;
    left: -10px;
    cursor: sw-resize;
  }

  > .multi-field-checkbox {
    position: absolute;
    top: -5px;
    right: -10px;
  }
}
</style>